//this code is used only for sestion 1 to section 8.
import React, { useState, useEffect, useRef, useContext } from 'react'
import { fetchAdminApi, fetchApi } from '../../services/api'
import { Row, Form, Col, Button, Space, Input, Spin, message, Table, Tooltip, Popconfirm, Select, Alert, Checkbox } from 'antd';
// import { luscherColorTest, template0, template1, template10, template11, template12, template14, template15, template16, template17, template2, template23, template4, template6, template9 } from '../../globalFunctions/GlobalFunctions';
import { template0, template1, template10, template11, template13, template2, template3, template4, template5, template6, template7, template8, template9, template15, template18, template19, template20, luscherColorTest, template24, template26, template12, templateYouTube, templateVideoStreaming, template29, template30, templeteJarOutline, templateGradtitude, template36, templateBucketList, template40, template37 } from './Templates';
import constants from '../../constants/constants';
import { COOKIE, getCookie } from '../../services/cookie';
import { DOB, popupMessage, template23, template28, uploadFile } from '../../globalFunctions/GlobalFunctions';
import { CheckOutlined, EditOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory } from "react-router";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import NotesModal from '../component/NotesModal';
import Template3 from '../component/Template3';

//Editable cells and rows Table code starts here
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	);
};
const EditableCell = ({
	editable,
	children,
	dataIndex,
	record,
	handleSaveTable,
	tableName,
	handleSaveTable2,
	handleAdd,
	disable,
	...restProps
}) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) {
			inputRef.current.focus();
		}
	}, [editing]);
	const toggleEdit = (param = null) => {
		setEditing(!editing);
		form.setFieldsValue({ [dataIndex]: record[dataIndex], });
	};
	//function to save and edit the cells
	const save = async (e) => {
		try {
			const values = await form.validateFields();
			toggleEdit();
			if (tableName === "Mylist" || tableName === "Mylist2" || tableName === "tableCode" || tableName === "AngerSheetTable" || tableName === "FearTable" || tableName === "BucketList") {
				if (e) {
					handleAdd("EDIT", {
						...record,
						...values,
					});
				}
				if (e.code === "Enter") {
					handleAdd("ADD", {
						...record,
						...values,
					}, tableName);
				}
			} else {
				if (e) {
					handleAdd("EDIT", {
						...record,
						...values,
					});
				}
			}
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};
	let childNode = children;
	if (editable) {
		childNode = editing ? (
			<Form.Item
				style={{ margin: 0, }}
				name={dataIndex}
			>
				<Input readOnly={disable} ref={inputRef} onPressEnter={save} onBlur={save} />
			</Form.Item>
		) : (
			<div
				className="editable-cell-value-wrap"
				style={{ paddingRight: 24, }}
				onClick={() => toggleEdit("text")}
			>
				{children}
			</div>
		);
	}
	return <td {...restProps}>{childNode}</td>;
};
const WorkbookSections = (props) => {
	const [form] = Form.useForm();
	const history = useHistory();
	const location = useLocation(); 
	const otherPathname = location.pathname; 
	const [loader, setLoader] = useState(false);
	//signature pad ref
	const sigPad = useRef(null);
	const adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const [esignValue, setEsignValue] = useState("");
	//Instrustion modal
	const [instructionModalOpen, setInstructionModalOpen] = useState(false);
	const [showInstnPopup, setShowInstnPopup] = useState(true);
	const [sectionData, setSectionData] = useState([]);
	const containerRef = useRef(null);
	const loginType = getCookie(COOKIE.LoginType);
	const [clientId, setClientId] = useState(props?.location?.state?.isAdmin || adminClientValuefromSession?.isAdmin ? props?.location?.state?.clientId || adminClientValuefromSession?.clientId : getCookie(COOKIE.ClientId));
	const [isResume, setIsResume] = useState({});
	const [counter, setCounter] = useState(() => {
		const persistedValue = sessionStorage.getItem('count');
		return persistedValue !== null ? JSON.parse(persistedValue) : 1;
	});
	const [sectionId, setSectionId] = useState(props?.location?.state?.section_id ? props?.location?.state?.section_id : sessionStorage.getItem('section_id'));
	const [planId, setPlanId] = useState(sessionStorage.getItem("plan_id") ?? props?.location?.state?.plan_id ?? null);
	const [enableTill, setEnableTill] = useState("");
	const [sectionLength, setSectionLength] = useState("");
	const [lastDiscussedPartId, setlastDiscussedPartId] = useState("");
	const [clientData, setClientData] = useState([]);
	const [reload, setReload] = useState(false);
	const [goToPageData, setGoToPageData] = useState([]);
	const [secZeroSubTitle, setSecZeroSubTitle] = useState([]);
	//notes
	const [notesVisible, setnotesVisible] = useState(false);
	const [noteValue, setNoteValue] = useState(null);
	const [noteTypeValue, setNoteTypeValue] = useState("0");
	const [notefollowUp, setNoteFollowUp] = useState(false);
	const [isNoteAnswered, setIsNoteAnswered] = useState(false);
	const [sessionChecked, setSessionChecked] = useState(false);
	const current = new Date();
	const [noteDate, setNoteDate] = useState({
		date: current.getDate(),
		month: String(current.getMonth() + 1).padStart(2, '0'),
		year: current.getFullYear()
	});
	const newUser = props?.location?.state?.new_user || adminClientValuefromSession?.new_user;
	//change jar
	let colored = JSON.parse(localStorage.getItem("colorValue"));
	const [isColored, setIsColored] = useState(colored!==null?colored.color:true);
	const [isColoredGratitudeJar, setIsColoredGratitudeJar] = useState(true);
	//upload file
	const [fileList, setFileList] = useState([]);
	//table with checkbox
	const [tableCheckedValues, setTableCheckedValues] = useState([]);
	//editable table
	const [tableOneDataSource, setTableOneDataSource] = useState([]);
	const tableComponents = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};
	const MaxLimit = 4;
	const [displayGamblingValidateMessage, setDisplayGamblingValidateMessage] = useState(false);
	const [assessmentBehavior, setAssessmentBehavior] = useState([]);
	const [isGamblingAnswered, setIsGamblingAnswered] = useState(false);
	const [activeMicIndex, setActiveMicIndex] = useState(null);
	const [facilitatorData, setFacilitatorData] = useState([]);
	const [isTestsPage, setIsTestsPage] = useState(false);
	const testPart = sessionStorage.getItem("testPartId");
	const [familyCodependencyMessage, setFamilyCodependencyMessage] = useState("");

	const tableOneColumns = [
		{
			title: sectionId === 4 ?'How can I respond better with anger?' : sectionId === 5 ? 'How can I respond better with fear?' :'',
			dataIndex: 'futureAction',
			width: '50%',
			editable: false,
			render: (futureAction) => {
				return Array.isArray(futureAction) ? futureAction.join(", ") : futureAction;
			}
		},
		/* {
			title: 'Action',
			dataIndex: 'operation',
			align: "center",
			width: '10%',
			render: (_, record) => {
				if (tableOneDataSource?.length > 1) {
					return <Tooltip title={constants.Delete}><Popconfirm disabled={adminClientValuefromSession?.isAdmin} title="Sure to Delete?" onConfirm={() => handleDelete(record.key,)}>
						<Button type="link" danger icon={<DeleteOutlined />} />
					</Popconfirm></Tooltip>;
				}
			}
		},*/
	];
	//lusher color test
	const colors = [
		"rgb(255, 51, 0)", /*Orange-Red color*/
		"rgb(255, 204, 0)", /*Bright Yellow color*/
		"rgb(0, 84, 71)", /*Blue-Green color*/
		"rgb(0, 0, 85)", /*Dark Blue color*/
		"rgb(153, 51, 0)", /*Brown color*/
		"rgb(153, 153, 153)", /*Grey color*/
		"rgb(0, 0, 0)", /*Black color*/
		"rgb(153, 0, 102)" /*Violet color*/
	];
	const [boxes, setBoxes] = useState([
		{
			id: 1,
			color: ""
		},
		{
			id: 2,
			color: ""
		},
		{
			id: 3,
			color: ""
		},
		{
			id: 4,
			color: ""
		},
		{
			id: 5,
			color: ""
		},
		{
			id: 6,
			color: ""
		},
		{
			id: 7,
			color: ""
		},
		{
			id: 8,
			color: ""
		},
	]);
	const [colorSequence, setColorSequence] = useState([]);
	// Anger sheet tables
	const [newSec4Option, setNewSec4Option] = useState(constants.Sec4FutureOptions);
	const [newSec5Option, setNewSec5Option] = useState(constants.Sec5FutureOptions);
	const [newOption, setNewOption] = useState('');
	const [newSec6Option, setNewSec6Option] = useState(constants.Sec6Options);
	const FutureInputRef = useRef(null);
	
	const handleBoxClick = (id, color, item_id) => {
		const updatedBoxes = boxes.map((box) => {
			if (box.id === id) {
				return {
					...box,
					visible: false
				};
			} else {
				return box;
			}
		});
		setBoxes(updatedBoxes);
		let colorName = null;
		if (color === "rgb(255, 51, 0)") {
			colorName = "Orange-Red";
		} else if (color === "rgb(255, 204, 0)") {
			colorName = "Bright Yellow";
		} else if (color === "rgb(0, 84, 71)") {
			colorName = "Blue-Green";
		} else if (color === "rgb(0, 0, 85)") {
			colorName = "Dark Blue";
		} else if (color === "rgb(153, 51, 0)") {
			colorName = "Brown";
		} else if (color === "rgb(153, 153, 153)") {
			colorName = "Grey";
		} else if (color === "rgb(0, 0, 0)") {
			colorName = "Black";
		} else if (color === "rgb(153, 0, 102)") {
			colorName = "Violet";
		}
		if (colorSequence.length > 0) {
			let found = false;
			for (let index = 0; index < colorSequence.length; index++) {
				const element = colorSequence[index];
				if (element !== colorName) {
					colorSequence.push(colorName);
					found = true;
				}
				if (found) {
					break;
				}
			}
		} else {
			colorSequence.push(colorName);
		}
		let check = allVisibleFalse(updatedBoxes);
		if (check) {
			if (loginType === "0") {
				let payload = {
					item_id: item_id,
					json_data: colorSequence,
					section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
				}
				clientData.push(payload);
				handleValidate("LusherColor");
			}
			setColorSequence([]);
		}
	};

	//upload file change
	const handleFileChange = ({ fileList }) => {
		setFileList(fileList);
	};

	//handle upload replace file.
	const handleRemove = (file) => {
		// remove the file from the fileList
		const index = fileList.indexOf(file);
		const newFileList = fileList.slice();
		newFileList.splice(index, 1);
		setFileList(newFileList);
	};

	//hadle function before upload file.
	function beforeUpload(file) {
		const isJpgOrPng =
			file.name.includes(".pdf") ||
			file.name.includes(".jpg") ||
			file.name.includes(".png") ||
			file.name.includes(".jpeg");
		if (!isJpgOrPng) {
			message.error("You can only upload PDF/JPEG/PNG file!");
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			message.error("Max file size accepted 2MB!");
		}
		return isLt2M;
	};

	// Function to check if all objects have visible set to false for lushur color test.
	function allVisibleFalse(data) {
		for (let i = 0; i < data.length; i++) {
			if (data[i].visible !== false) {
				return false;
			}
		}
		return true;
	};

	//func to get random color for lushur color test.
	const updateBoxColors = () => {
		//genereting different colors
		const shuffledColors = colors.sort(() => 0.5 - Math.random());
		const initialBoxes = shuffledColors.map((color, index) => {
			return {
				id: index + 1,
				color: color,
				visible: true
			};
		});
		setBoxes(initialBoxes);
	};

	//To reset lushur color test.
	const resetLusherColor = () => {
		let payload = { client_id: adminClientValuefromSession?.clientId };
		fetchAdminApi(`/reset-luscher-color`, "post", payload).then((res) => {
			if (res && res.code === 200) {
				fetchWorkbookSections(sectionId, counter);
				message.success(res.message);
			} else {
				message.error(res.message);
			}
		});
	};

	//download lusher color result
	const downloadResult = (sectionData=null) => {
		let documentValue = {
			client_id: adminClientValuefromSession?.clientId, /*"client_id from admin login"*/
			file_type: "result-pdf",
		};
		if(sectionData!==null){
			documentValue.doc_name = sectionData?.content_left;
			documentValue.file_type = "section-pdf";
		}
		sessionStorage.setItem("documentValue", JSON.stringify(documentValue));
		window.open(constants.BaseUrl + `/view-document`);
	};

	//function to delete row from a editable table
	const handleDelete = (key) => {

		// Find the record to be deleted
		const recordToDelete = tableOneDataSource.find((item) => item.key === key);
		if (!recordToDelete) {
			return; // If no record found, do nothing
		}

		const isAngerSheet = recordToDelete.table === "AngerSheetTable";

		if (isAngerSheet) {
			// ── ANGER SHEET LOGIC ──────────────────────────────────────────
			const compareValue = recordToDelete.name;

			let updatedData = tableOneDataSource.filter((item) => item.key !== key);

			// Find duplicates dynamically
			const recordsWithSameName = updatedData.filter((item) => item.name === compareValue);

			if (recordsWithSameName.length > 0) {

				// Re-evaluate isDuplicate for the entire group
				updatedData = updatedData.map((item, _, arr) => {
					const group = arr.filter(r => r.name === item.name);
					const isFirstInGroup = group[0].key === item.key;

					return {
						...item,
						isDuplicate: group.length > 1 ? !isFirstInGroup : false
					};
				});
			}

			// Reassign keys sequentially to prevent duplicate key issues after adds/deletes
			updatedData = updatedData.map((item, index) => ({ ...item, key: index + 1 }));
			setTableOneDataSource(updatedData);

		} else {
			// ── (flaws-based) ──────────────────────────
			const { flaws } = recordToDelete;

			// Filter out the record to be deleted
			const updatedData = tableOneDataSource.filter((item) => item.key !== key);

			// Find all records with the same name
			const recordsWithSameName = updatedData.filter((item) => item.flaws === flaws);

			if (recordsWithSameName.length > 0) {
				// Find the record with the lowest key among the duplicates
				const recordWithLowestKey = recordsWithSameName.reduce((lowest, item) => {
					return item.key < lowest.key ? item : lowest;
				}, recordsWithSameName[0]);

				// Update its `isDuplicate` property to false
				recordWithLowestKey.isDuplicate = false;
			} else {
				console.error("No records with the same name found.");
			}

			// Update the state with the modified data
			setTableOneDataSource([...updatedData]);
		}
	};

	// function for dropdown table
	const handleChange = (e, record) => {
		const prevValue = Array.isArray(record || []);

		// Adding warning message beyond limit
		if (Array.isArray(e) && e.length > MaxLimit && e.length > prevValue.length) {
			message.warning(`You can select up to ${MaxLimit} options only`);
			return;
		}

		const updatedDataSource = tableOneDataSource.map((element) => {
			if (element.key === record.key) {
				return {
					...element,
					affected: e
				};
			}
			return element;
		});
		setTableOneDataSource(updatedDataSource);
	};

	// function for Anger sheet table 3
	const handleFearChange = (e, record) => {
		const array = typeof e;
		const result = array !== "string" ? e?.join(", ") : e;
		const updatedDataSource = tableOneDataSource.map((element) => {
			if (element.key === record.key) {
				return {
					...element,
					fearAction: result
				};
			}
			return element;
		});
		setTableOneDataSource(updatedDataSource, "fearAction");
	};

	const handleFearInputChange = (e, record) => {
		const updatedDataSource = tableOneDataSource.map((element) => {
			if (element.key === record.key) {
				return {
					...element,
					fearCause: e.target.value
				};
			}
			return element;
		});
		setTableOneDataSource(updatedDataSource);
	};


	const handleCheckboxChange = (key, checked) => {

		// Update the specific record in the data source
		const updatedDataSource = tableOneDataSource.map((item) => {
			if (item.key === key) {
				return { ...item, isChecked: checked };
			}
			return item;
		});

		setTableOneDataSource(updatedDataSource);
	};

	// function for dropdown table - Anger Sheet
	const handleFutureChangeAndMyreaction = (e, record, type) => {
		const prevValue = Array.isArray(record[type]) ? record[type] : [];

		// Adding warning message beyond limit
		if (Array.isArray(e) && e.length > MaxLimit && e.length > prevValue.length) {
			message.warning(`You can select up to ${MaxLimit} options only`);
			return;
		}

		const updatedDataSource = tableOneDataSource.map((element) => {
			if (element.key === record.key) {
				return {
					...element,
					[type]: e,
				};
			}
			return element;
		});
		setTableOneDataSource(updatedDataSource);
	};

	// Update new option value
	const handleNewOptionChange = (e) => {
		setNewOption(e.target.value);
	};
	const handleAddNewOption = (condition) => {
		if (!newOption) return;
		if(condition ==="Anger Sheet table"){
			setNewSec4Option([...newSec4Option, newOption])
		}else if(condition==="table code"){
			setNewSec6Option([...newSec6Option, newOption])
		}else{
			setNewSec5Option([...newSec5Option, newOption]);
		}
		
		setNewOption('');
		setTimeout(() => FutureInputRef.current?.focus(), 0);
	};

	//function to add a row on specific position.
	const handleAddOnSpecificIndex = (index, tableType) => {
		let newEntry = {
			...tableOneDataSource[index - 1],
			key: tableOneDataSource.length + 1,
			isDuplicate: true
		};
		// changed is_ticked value to false to unable delete button
		newEntry.is_ticked = false;

		if (tableType === "tableCode") {
			newEntry = {
				...newEntry,
				name: "",
				problem: "",
				affected: ""
			};
		} else if (tableType === "AngerSheetTable") {
			newEntry = {
				...newEntry,
				problem: "",
				affected: "",
				reaction: "",
				futureAction: ""
			};
		} else if (tableType === "FearTable") {
			newEntry = {
				...newEntry,
				fearCause: ``,
				affected: ``,
				fearAction: ``,
				futureAction: ``,
			};
		} else if (tableType === "Anger Sheet table 2"){
			newEntry = {
				...newEntry,
				is_add: true,
				fearCause: ``,
				fearAction: ``,
				futureAction: ``,
				myreaction:``,
				affected:``
			};
		}

		const updatedDataSource = [
			...tableOneDataSource.slice(0, index),
			newEntry,
			...tableOneDataSource.slice(index)
		];

		setTableOneDataSource(updatedDataSource);
	};

	// function to save the table data (particular row)
	const handleActionSave = (record, value) => {
		const index = tableOneDataSource.findIndex((item) => record.key === item.key);
		let userPayload = [];
		let payload = {
			item_id: value?.item_id,
			json_data: tableOneDataSource,
			section_id: sectionId
		}
		userPayload.push(payload);
		if (index > -1) {
			let previousData = value?.client_ans !== null ? value?.client_ans[index] : [] || value?.fears[index];
			let updatedData = tableOneDataSource[index];
			if (JSON.stringify(previousData) !== JSON.stringify(updatedData)) {
				addAnswers(userPayload, "show success message");
			} else {
				message.error("No data to Save")
			}
		}
	};
	//function to add the row to the editable table
	const handleAdd = (param = null, row, table = null, addRow = null) => {
		let dataSource = [...tableOneDataSource];
		if (param === "ADD") {
			let index = dataSource.findIndex((item) => item.key === row.key);
			if (addRow !== null) {
				dataSource.push(row);
				setTableOneDataSource(dataSource);
			}
			if (index > -1) {
				dataSource[index] = row;
				if (dataSource[dataSource.length - 1].name !== "") {
					if (table === "AngerSheetTable") {
						dataSource.push({
							key: tableOneDataSource.reduce((previous, current) => {
								return current.key > previous.key ? current : previous;
							}).key + 1,
							name: ``,
							problem: ``,
							affected: ``,
							futureAction: ``,
							reaction: ``,
							is_pushed: 0,
							table: "AngerSheetTable",
						});
						setTableOneDataSource(dataSource);
					} else if (table === "FearTable") {
						dataSource.push({
							key: tableOneDataSource.reduce((previous, current) => {
								return current.key > previous.key ? current : previous;
							}).key + 1,
							name: ``,
							fearAction: ``,
							fearCause: ``,
							affected: ``,
							futureAction: ``,
							is_pushed: 0,
							table: "FearTable",
						});
						setTableOneDataSource(dataSource);
					} else if (table === "tableCode") {
						dataSource.push({
							key: tableOneDataSource.reduce((previous, current) => {
								return current.key > previous.key ? current : previous;
							}).key + 1,
							name: ``,
							flaws: ``,
							problem: ``,
							affected: ``,
							is_pushed: 0,
							table: "tableCode",
						});
						setTableOneDataSource(dataSource);
					}
				}
			}
		} else if (param === "EDIT") {
			let index = dataSource.findIndex((item) => item.key === row.key);
			if (dataSource[index].name !== row.name || dataSource[index].problem !== row.problem || dataSource[index].affected !== row.affected || dataSource[index].futureAction !== row.futureAction || dataSource[index].reaction !== row.reaction || dataSource[index].fearCause !== row.fearCause || dataSource[index].fearAction !== row.fearAction) {
				dataSource[index] = row;
				setTableOneDataSource(dataSource);
			}
		}
	};

	const handleAddBucket = (param = null, row, table = null, addRow = null) => {
		let dataSource = [...tableOneDataSource];
	
		const getNewKey = () => {
			const maxKey = dataSource.reduce((max, item) =>
				item.key > max ? item.key : max
			, 0);
			return maxKey + 1;
		};
	
		if (param === "ADD") {
			if (addRow !== null) {
				dataSource.push({
					...row,
					key: getNewKey()
				});
				setTableOneDataSource(dataSource);
				return;
			}
	
			if (table === "BucketList") {
				dataSource.push({
					key: getNewKey(),
					bucket: "",
					section: row.section,
					table: "BucketList",
					is_pushed: 0,
					item_id: null
				});
				setTableOneDataSource(dataSource);
				return;
			}
	
			let index = dataSource.findIndex((item) => item.key === row.key);
			if (index > -1) {
				dataSource[index] = row;
			}
		}
	
		else if (param === "EDIT") {
			let index = dataSource.findIndex((item) => item.key === row.key);
			if (index > -1) {
				dataSource[index] = row;
			}
		}
	
		setTableOneDataSource(dataSource);
	};

	useEffect(() => {
		fetchWorkbookSections(sectionId, testPart? (Number(testPart) + (counter-1)) :counter, otherPathname);
	}, [otherPathname, counter]);

	useEffect(() => {
	}, [reload]);

	useEffect(() => {
		updateBoxColors();
		if (props?.location?.state?.section_id) {
			sessionStorage.setItem('section_id', props?.location?.state?.section_id);
		}
		return () => {
			localStorage.removeItem('colorValue');
			sessionStorage.removeItem('testPartId');
		}
	}, []);

	//handle table data entered by client.
	const handleEditableTableClientData = () => {
		// Find either template 15 or 39
		const findIndex = sectionData?.findIndex((val) =>
			val?.template_id === "15" || val?.template_id === "39"
		);

		if (findIndex > -1) {
			const currentSection = sectionData[findIndex];
			let updatedData = JSON.stringify(tableOneDataSource);
			let previousData = JSON.stringify(currentSection.client_ans);
			if (updatedData !== previousData) {
				let payload = {
					item_id: currentSection.item_id,
					section_id: sectionId,
					json_data: tableOneDataSource
				};
				if (currentSection?.is_discussed === 1) {
					payload.is_changed = 1;
				};
				clientData.push(payload);
			}
		}
	};

	const handleCheckboxTableClientData = () => {
		let temp15Index = sectionData?.findIndex((val) => val?.template_id === "18");
		if (temp15Index > -1) {
			let previousData = sectionData[temp15Index].client_ans
			let updatedData = tableCheckedValues;
			if (JSON.stringify(previousData) !== JSON.stringify(updatedData)) {
				let userPayload = {
					item_id: sectionData[temp15Index].item_id,
					json_data: updatedData,
					section_id: sectionId
				}
				if (sectionData[temp15Index].content_left === "Anger Sheet table 3") {
					userPayload.option_data = "1"
				}
				if (sectionData[temp15Index]?.is_discussed === 1) {
					userPayload.is_changed = 1;
				}
				clientData.push(userPayload);
			}
		}
	};

	//fetch workbook data
	const fetchWorkbookSections = (sectionId, part, pathname) => {
		setLoader(true);

		const endpointMap = {
			"/workbook-tests": `/display-dast-test/${clientId}`,
			"/coaching-form": `/display-coaching-agreement/${clientId}`,
			"/commitment-form": `/display-commitment-form/${clientId}`,
			"/suicidal-form": `/display-sucidal-consent-form/${clientId}`,
		};
		const test = {
			"/tests": `/get-sections`,
		};
		const isFormPath = Object.keys(endpointMap).includes(pathname);
		const isAdminUrl = Object.keys(test).includes(pathname);
		setIsTestsPage(isAdminUrl);
		const url = isFormPath ? endpointMap[pathname]: isAdminUrl ? test[pathname]: `/get-sections/${clientId}`;
		const payload = isFormPath ? { part } : { section: sectionId, part,  ...(adminClientValuefromSession?.isAdmin && { admin: 1 }) };
		payload.plan_id = (planId === "null" || planId === "" || planId === undefined || planId === "undefined") ? null : planId;
		let method = "post"
		fetchApi(url, method, payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				handleInitialTableData(res?.data[part]);
				setIsResume(res?.is_resume);
				setFacilitatorData(Array.isArray(res?.facilitator) ? res.facilitator : []);
				setSectionData(res?.data[part]);
				setGoToPageData(res?.section_page_title);
				let result = checkGamblingOption(res?.data[part]);
				setDisplayGamblingValidateMessage(result);
				const currentPageTitle = res?.sub_titles?.find((item) => Number(item?.page_no) === Number(part))?.page_title;
				let FamilyCodepedency = checkFamilyCodependencyOption(res?.data[part], currentPageTitle);
				setFamilyCodependencyMessage(FamilyCodepedency);
				let showHideNextButtonValue = showHideNextButton(res?.data[part]);
				setIsGamblingAnswered(showHideNextButtonValue);
				setEnableTill(parseInt(res?.enabled_page));
				setSectionLength(parseInt(res?.section_length));
				setlastDiscussedPartId(res?.last_discussed_part_id);
				setSecZeroSubTitle(res?.sub_titles);
				let checkboxTableIndex = res?.data[part]?.findIndex((val) => val?.template_id === "18");
				setTableCheckedValues(res?.data?.[part]?.[checkboxTableIndex]?.client_ans ?? []) ;
				let findIndex = res?.data[part]?.findIndex((val) => val?.section_res);
				if (findIndex > -1) {
					//setting form fields for summary.
					setFormItemValues(res?.data?.[part]?.[findIndex]?.section_res, res?.data?.[part]?.[findIndex]?.section_id);
				} else {
					setFormItemValues(res?.data[part]);
				}
				//instruction modal for loginType zero.
				if (counter === 1 && loginType === "0" && res?.show_section_popup && showInstnPopup) {
					// setIsCompleteSectionPopup(true);
					setShowInstnPopup(false);
					showInstructionModal();
				}
				// else{
				//   setIsCompleteSectionPopup(false);
				// }

				// For coaching agreement PDF
				if (pathname === "/coaching-form" && part === 2) {
					sessionStorage.setItem(`coaching_part_${part}`, JSON.stringify(res?.data?.[part] || []));
				}
			} else {
				setSecZeroSubTitle([]);
				setFacilitatorData([]);
				setEnableTill("");
				setSectionLength("");
				setSectionData([]);
				setlastDiscussedPartId("");
				setFamilyCodependencyMessage("");
				setGoToPageData([]);
				setIsResume({});
				setLoader(false);
			}
		})
	};

	// Function to format the cost in the PDF.
	const formatNumber = (value, currency) => {
		if (!value) return '';
		if (currency === 'INR') {
			return `${value}`.replace(/(\d)(?=(\d\d)+\d(\.\d{0,2})?$)/g, '$1,');
		} else {
			return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		}
	};
	const getCurrency = (amount) => {
		if (amount.includes('INR')) return 'INR';
		if (amount.includes('USD')) return 'USD';
		return null;
	};
	const extractAmount = (amount) => {
		const matches = amount.match(/\d+(,\d{3})*(\.\d{1,2})?/);
		return matches ? matches[0] : '';
	};
	const formatAmountString = (amount) => {
		const currency = getCurrency(amount);
		const numericValue = extractAmount(amount).replace(/,/g, '');
		const formattedValue = formatNumber(numericValue, currency);
		return amount.replace(numericValue, formattedValue);
	};
	const getHtmlCode = () => {
		let html = containerRef.current?.innerHTML || '';
		if (!html) return '';

		const container = document.createElement('div');
		container.innerHTML = html;

		// Remove elements with class 'family' and style 'display: none'
		const elementsToRemove = container.querySelectorAll('.family[style*="display: none"]');
		elementsToRemove?.forEach(element => element.remove());

		// to replace the html string for special scholarship client.
		const searchScholarship = container.querySelectorAll("div[id=commit-to-pay]");
		const searchScholarshipText = container.querySelectorAll("div[id=commit-to-pay-text]");

		let perSessionCost = null;
		let programCost = null;
		let totalPlanCost = null;
		let wbdata = allCoachingParts.flat?.() || allCoachingParts;;

		for (const element of wbdata) {
			if (element.content_left.includes("Per Session Cost") && element.client_ans != null) {
				perSessionCost = element?.client_ans;
			} else if (element.content_left.includes("Program Cost") && element.client_ans != null) {
				programCost = element?.client_ans;
			} else if (element.content_left.includes("Total Plan Cost") && element.client_ans != null) {
				totalPlanCost = element?.client_ans;
			}
		}

		if (searchScholarship.length > 0) {
			searchScholarship?.forEach(value => {
				const text = perSessionCost ? '<b class="color-red">Per Session Cost </b>' : '<b class="color-red">Program Cost </b>';
				const cost = perSessionCost || programCost || "";
				const formattedCost = formatAmountString(cost);
				value.insertAdjacentHTML('beforebegin', `${text}: <b>${formattedCost}</b>`);
				value.remove();
			});
		}

		if (searchScholarshipText.length > 0) {
			searchScholarshipText?.forEach(value => {
				const text = '</br><b class="color-red">Total Plan Cost </b>';
				const formattedTotalCost = formatAmountString(totalPlanCost);
				value.insertAdjacentHTML('beforebegin', `${text}: <b>${formattedTotalCost}</b>`);
				value.remove();
			});
		}
		const finalHtml = container.innerHTML;
		return finalHtml;

	};

	const allCoachingParts = [
		JSON.parse(sessionStorage.getItem("coaching_part_2") || "[]"),
	];

	//setting initial table data for template 15.
	const handleInitialTableData = (data) => {
		const findIndex = data?.findIndex((val) =>
			val?.template_id === "15" || val?.template_id === "39"
		);

		if (findIndex > -1) {
			if (data[findIndex].client_ans === null) {
				if (data[findIndex].content_left === "Anger Sheet table") {
					let datasource = [];
					if (Array.isArray(data[findIndex].anger) && data[findIndex].anger.length > 0) {
						datasource = data[findIndex].anger.map((angerItem, index) => ({
							key: index + 1,
							name: angerItem.name,
							problem: ``,
							affected: ``,
							reaction: ``,
							futureAction: ``,
							table: "AngerSheetTable",
							is_pushed: 0,
							item_id:angerItem.item_id
						}));
					}
					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "Anger Sheet table 2") {
					let datasource = [];
					if (Array.isArray(data[findIndex].fears) && data[findIndex].fears.length > 0) {
						datasource = data[findIndex].fears.map((fear, index) => ({
							key: index + 1,
							name: fear.name || ``,
							fearCause: fear.fearCause || ``,
							affected: ``,
							fearAction: fear.fearAction || ``,
							futureAction: fear.futureAction || ``,
							table: "FearTable",
							is_pushed: 0,
							is_add: false,
							is_ticked: fear?.is_ticked,
							item_id:fear.item_id,
							myreaction:fear.myreaction,
							isDuplicate:false
						}));
					}
					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "table code") {
					let datasource = [];
					if (Array.isArray(data[findIndex].flaws) && data[findIndex].flaws.length > 0) {
						datasource = data[findIndex].flaws.map((flaw, index) => ({
							key: index + 1,
							flaws: flaw.flaws,
							name: ``,
							problem: ``,
							affected: ``,
							table: "tableCode",
							is_pushed: 0,
							is_ticked: flaw?.is_ticked,
						}));
					}
					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "My List Table") {
					let datasource = [];
					if (data[findIndex].future_action && data[findIndex].future_action.length > 0) {
						const futureActionsArray = data[findIndex].future_action || [];
						datasource = futureActionsArray.map((action, index) => ({
							key: index + 1,
							futureAction: action,
							table: "MyList",
							is_pushed: 0
						}));
					}
					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "Anger Sheet table 3") {
					let datasource = [];
					if (data[findIndex].type_left === "T") {
						datasource = constants.AngerSheetTableAllType.map((type, index) => ({
							key: index + 1,
							name: type,
							isChecked: ``,
							fearCause: ``,
							fearAction: null,
							futureAction: ``,
							table: "AngerSheetTable3",
							is_pushed: 0,
							item_id: null,
							myreaction:null
						}));
					}
					setTableOneDataSource(datasource);
				}
				else if(data[findIndex].content_left === "My Bucket List"){
					setTableOneDataSource(constants.DefaultBucketSectionList);
				}
			} else {
				if (data[findIndex].content_left === "table code") {
					let datasource = [];
					let currentKey = 1;
					if (Array.isArray(data[findIndex].flaws) && data[findIndex].flaws.length > 0) {
						data[findIndex].flaws?.forEach((flaw) => {
							const existingRecord = data[findIndex].client_ans.find(
								(ans) => ans.flaws === flaw.flaws && ans.key === flaw.key
							);
							if (existingRecord) {
								datasource.push({
									...existingRecord,
									key: currentKey++
								});
							} else {
								datasource.push({
									key: currentKey++,
									flaws: flaw.flaws,
									name: ``,
									problem: ``,
									affected: ``,
									table: "tableCode",
									is_pushed: 0,
								});
							}
						});
					}
					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "Anger Sheet table") {
					let datasource = [];
					let currentKey = 1;

					const angerList = data[findIndex].anger || [];
					const clientAns = data[findIndex].client_ans || [];

					// STEP 1 — If no anger, clear datasource
					if (!Array.isArray(angerList) || angerList.length === 0) {
						datasource = [];
						return;
					}

					// STEP 2 — Group anger by NAME
					const groupedByName = {};

					angerList?.forEach((item, i) => {
						const name = item.name?.trim() || "";

						if (!groupedByName[name]) {
							groupedByName[name] = [];
						}
						groupedByName[name].push(item);
					});

					// STEP 3 — Build datasource
					Object.keys(groupedByName)?.forEach(name => {
						const group = groupedByName[name];

						group?.forEach((angerItem, index) => {

							// Try match client_ans
							let matchedClient = clientAns.find(c => c.key === angerItem.key);

							// STEP 4 — If no match → create new object
							if (!matchedClient) {
								matchedClient = {
									name: name,
									problem: ``,
									affected: ``,
									reaction: ``,
									futureAction: ``,
									table: "AngerSheetTable",
									is_pushed: 0,
									item_id: angerItem.item_id || null
								};
							}

							// STEP 5 — Push with corrected duplicate flag
							const isDuplicate = group.length > 1 ? index !== 0 : false;
							const newRow = {
								...matchedClient,
								key: currentKey++,
								isDuplicate
							};

							datasource.push(newRow);
						});
					});

					setTableOneDataSource(datasource);
				} else if (data[findIndex].content_left === "Anger Sheet table 2") {
					let datasource = [];
					let currentKey = 1;
					if (Array.isArray(data[findIndex].fears) && data[findIndex].fears.length > 0) {
						data[findIndex].fears?.forEach((fear) => {
							const existingRecord = data[findIndex].client_ans.find((ans) => ans.name === fear.name && ans.key === fear.key);
							if (existingRecord) {
								datasource.push({
									...existingRecord,
									key: currentKey++,
									name: fear.name,
									is_add: fear?.is_add
								});
							} else {
								datasource.push({
									key: currentKey++,
									name: fear.name,
									fearCause: fear.fearCause || ``,
									affected: fear.affected || ``,
									fearAction: fear.fearAction || ``,
									futureAction: fear.futureAction ||``,
									table: "FearTable",
									is_pushed: 0,
									is_add: fear?.is_add,
									is_ticked: fear?.is_ticked,
									item_id:fear.item_id,
									myreaction:fear.myreaction || ``,
								});
							}
						});
					}
					setTableOneDataSource(datasource);
				}  
				else if (data[findIndex].content_left === "Anger Sheet table 3") {
					let datasource = data[findIndex].client_ans?.length > 0 ? data[findIndex].client_ans?.sort((a, b) => a.name.localeCompare(b.name)) : [];
					setTableOneDataSource(datasource);
				}
				else if (data[findIndex].content_left === "My List Table") {
					let datasource = [];
					let currentKey = 1;
					if (data[findIndex].future_action && data[findIndex].future_action.length > 0) {
						const futureActionsArray = data[findIndex].future_action || [];

						futureActionsArray?.forEach((action) => {
							const existingRecord = data[findIndex].client_ans.find((ans) => ans.futureAction === action);
							if (existingRecord) {
								datasource.push({
									...existingRecord,
									key: currentKey++
								});
							} else {
								datasource.push({
									key: currentKey++,
									futureAction: action,
									table: "MyList",
									is_pushed: 0
								});
							}
						});
					}
					setTableOneDataSource(datasource);
				} else {
					setTableOneDataSource(data[findIndex].client_ans);
				}
			}
		}
	};

	//setting form field values
	const setFormItemValues = (arrayValue, section_id = null) => {
		for (let index = 0; index < arrayValue?.length; index++) {
			const element = arrayValue[index];
			if (section_id !== null) {
				//setting summary value in section 7 and section 1
				//setting form value. Using a index as a key.
				if (section_id === "7" || section_id === "8" || section_id === "100") {
					form.setFieldsValue({ [index]: element.client_ans });
				} else {
					form.setFieldsValue({ [element.item_id]: element.client_ans });
				}
			} else {
				form.setFieldsValue({ [element.item_id]: element.client_ans });
			}
		}
	};

	//rendering templates
	const renderTemplate = (section) => {
		return (
			<>
				{selectTemplate(section)}
			</>
		);
	};

	//handle change for all the common template onchange func.
	const onChangeTemplete = (e, data, type, isSummary) => {
		if (e || data.client_ans !== null) {
			if (clientData.length > 0) {
				let found = false;
				for (let i = 0; i < clientData.length; i++) {
					if (clientData[i].item_id === data.item_id) {
						if (type === "text") {
							clientData[i].textValue = e === "" ? null : e;
						} else {
							clientData[i].option_data = e
						}
						found = true;
						// Removing the object from clientData when e ==="0" & section_id =0. this is for validation purpose
						if (sectionId === "0") {
							if (clientData[i].textValue === "" && type === "text") {
								clientData.splice(i, 1);
							}
						}
						if (isSummary) {
							clientData[i].is_summary = isSummary;
							if (sectionId !== "8") {
								clientData[i].is_checked = 1;
							}
						}
						break;
					}
				}
				if (!found) {
					let payload = null;
					payload = {
						item_id: data.item_id,
						section_id: data?.section_id ? data?.section_id : sectionId,
					};
					if (type === "text") {
						payload.textValue = e === "" ? null : e;
					} else {
						payload.option_data = e;
					}
					updatePayloadForRbTf(data, payload, type, e);
					if (data?.is_discussed === 1) {
						payload.is_changed = 1;
					}
					if (isSummary) {
						payload.is_summary = isSummary;
						if (sectionId !== "8") {
							payload.is_checked = 1;
						}
					}
					clientData.push(payload);
				}
			} else {
				let payload = null;
				payload = {
					item_id: data.item_id,
					section_id: data?.section_id ? data?.section_id : sectionId,
				};
				if (type === "text") {
					payload.textValue = e === "" ? null : e;
				} else {
					payload.option_data = e;
				}
				if (data?.is_discussed === 1) {
					payload.is_changed = 1;
				}
				updatePayloadForRbTf(data, payload, type, e);
				if (isSummary) {
					payload.is_summary = isSummary;
					if (sectionId !== "8") {
						payload.is_checked = 1;
					}
				}
				clientData.push(payload);
			}
		}
		//gambling validation;
		if (data.item_id === "1048" || data.item_id === "1036" || data.item_id === "1658" || data.item_id === "1657") {
			let getIndex = sectionData.findIndex((val) => val.item_id === data.item_id);
			sectionData[getIndex].client_ans = e;
			let result = checkGamblingOption(sectionData);
			setDisplayGamblingValidateMessage(result);
		}
		// Family and codependency screening validation
		if (data?.template_id === 7 || data?.template_id === "7") {
			const getIndex = sectionData.findIndex(
				(item) => item.item_id === data.item_id
			);

			if (getIndex !== -1) {
				sectionData[getIndex].client_ans = e;
				const currentPageTitle = secZeroSubTitle[counter - 1]?.page_title;
				const message = checkFamilyCodependencyOption(sectionData, currentPageTitle);
				setFamilyCodependencyMessage(message);
			}
		}
	};

	const updatePayloadForRbTf = (data, payload, type, e) => {
		if (data?.type_left !== "RB" || data?.type_right !== "TF") return;
		if (type === "radio") {
			payload.option_data = e;
			if (data?.content_right !== null) {
				payload.textValue = data?.content_right;
			}
		} else {
			payload.textValue = e === "" ? null : e;
			if (data?.client_ans !== null) {
				payload.option_data = data?.client_ans;
			}
		}
	};

	//onchange function for template with checkbox and textfield
	const onChangeCheckboxValue = (e, data, template_id) => {
		let tempDataCheckbox;
		if (e) {
			tempDataCheckbox = sectionData.filter((item) => (
				item.template_id === template_id
			));
			tempDataCheckbox.map((item, index) => {
				if (item.item_id === data.item_id) {
					if (e.target.checked === false) {
						if (clientData.length > 0) {
							let found = false;
							for (let i = 0; i < clientData.length; i++) {
								if (clientData[i].item_id === data.item_id) {
									clientData.splice(i, 1);
									found = true;
									break;
								}
							}
							if (!found) {
								if (item.client_ans || item.check_box === "t") {
									let payload = null;
									payload = {
										item_id: data.item_id,
										section_id: data?.section_id,
										option_data: 2
									};
									if (data?.is_discussed === 1) {
										payload.is_changed = 1;
									}
									// Template 19, section 7, page 6 needs the checkboxes ticked by user to be displayed on the summary page.
									if (data.section_id === "7" && data.section_type === "1" && data.part_id === "6" && data.template_id === "19") {
										payload.is_checked = e.target.checked === true ? '1' : '0';
									}
									clientData.push(payload);
								}
							}
						} else {
							if (item.client_ans || item.check_box === "t") {
								let payload = null;
								payload = {
									item_id: data.item_id,
									section_id: data?.section_id,
									option_data: 2
								};
								if (data?.is_discussed === 1) {
									payload.is_changed = 1;
								}
								// Template 19, section 7, page 6 needs the checkboxes ticked by user to be displayed on the summary page.
								if (data.section_id === "7" && data.section_type === "1" && data.part_id === "6" && data.template_id === "19") {
									payload.is_checked = e.target.checked === true ? '1' : '0';
								}
								clientData.push(payload);
							}
						}
						let findIndex = sectionData.findIndex((val) => val?.item_id === data?.item_id);
						sectionData[findIndex].client_ans = "";
					} else {
						if (clientData.length > 0) {
							let found2 = false;
							for (let j = 0; j < clientData.length; j++) {
								if (clientData[j].item_id === data.item_id) {
									clientData[j].option_data = 1;
									found2 = true;
									break;
								}
							}
							if (!found2) {
								let payload = null;
								payload = {
									item_id: data.item_id,
									section_id: data?.section_id,
									option_data: 1
								};
								if (data?.is_discussed === 1) {
									payload.is_changed = 1;
								}
								// Template 19, section 7, page 6 needs the checkboxes ticked by user to be displayed on the summary page.
								if (data.section_id === "7" && data.section_type === "1" && data.part_id === "6" && data.template_id === "19") {
									payload.is_checked = e.target.checked === true ? '1' : '0';
								}
								clientData.push(payload);
							}
						} else {
							let payload = null;
							payload = {
								item_id: data.item_id,
								section_id: data?.section_id,
								option_data: 1
							};
							if (data?.is_discussed === 1) {
								payload.is_changed = 1;
							}
							// Template 19, section 7, page 6 needs the checkboxes ticked by user to be displayed on the summary page.
							if (data.section_id === "7" && data.section_type === "1" && data.part_id === "6" && data.template_id === "19") {
								payload.is_checked = e.target.checked === true ? '1' : '0';
							}
							clientData.push(payload);
						}
					}
					tempDataCheckbox[index].check_box = e.target.checked === true ? 't' : 'f';
				}
			});
		}
		setReload(!reload);
	};

	const onCheckboxChange = (e, tempData) => {
		const isChecked = e.target.checked;
		let payload = {
			item_id: tempData?.item_id,
			section_id: sectionId === 7 || sectionId === 8 ? tempData?.section_id : sectionId,
			is_checked: isChecked ? "1" : "0",
		};

		// Template 36, section 7, page 5 needs the checkboxes ticked by user to be displayed on the summary page.
		if (tempData?.template_id === "36") {
			payload.option_data = 1;
		}

		clientData.push(payload);
		setReload(!reload);
	}

	const onCheckboxSummaryChange = (e, tempData) => {
		const isChecked = e.target.checked;
		let payload = {
			item_id: tempData?.item_id,
			section_id: sectionId === 7 || sectionId === 8 ? tempData?.section_id : sectionId,
			is_summary: isChecked ? "2" : "0",
			option_data: 1,
		};

		if (tempData?.client_ans) {
			payload.textValue = tempData?.client_ans;
		}

		clientData.push(payload);
		setReload(!reload);
	}
	
	const onchangeTextBox = (e, data, template_id) => {
		let tempTextValue;
		tempTextValue = sectionData.filter((item) => (
			item.template_id === template_id
		));
		tempTextValue.map((item, index) => {
			if (item.item_id === data.item_id) {
				tempTextValue[index].client_ans = e.target.value;
				if (clientData.length > 0) {
					let found = false;
					for (let i = 0; i < clientData.length; i++) {
						if (clientData[i].item_id === data.item_id) {
							clientData[i].textValue = e.target.value;
							found = true;
							break;
						}
					}
					if (!found) {
						let payload = null;
						payload = {
							item_id: data.item_id,
							textValue: e.target.value,
							section_id: data?.section_id,
						};
						if (data?.is_discussed === 1) {
							payload.is_changed = 1;
						}
						clientData.push(payload);
					}
				} else {
					let payload = null;
					payload = {
						item_id: data.item_id,
						textValue: e.target.value,
						section_id: data?.section_id,
					};
					if (data?.is_discussed === 1) {
						payload.is_changed = 1;
					}
					clientData.push(payload);
				}
			}
		});
		setReload(!reload);
	};

	//onchange for checkbox table template. 
	const onChangeCheckboxTable = (checkedValue) => {
		setTableCheckedValues(checkedValue);
	};

	//clear signature pad
	const clearSignaturePad = () => {
		sigPad.current.clear();
		setEsignValue("");
	};

	//handle signature pad value
	function handleSignPadVal() {
		// Get the data URL of the signature image
		const dataUrl = sigPad.current.toDataURL();
		setEsignValue(dataUrl);
	};

	// New Template for checkbox based on check_box
	const checkboxGrid = (content_left, data, disable) => {
		const onChangeCheckboxValue = (e) => {
			if (!e) return;

			const isChecked = e.target.checked;
			const optionValue = isChecked ? '1' : '0';
			const checkBoxValue = isChecked ? 't' : 'f';

			// Update sectionData (in-place mutation, similar to how you're doing elsewhere)
			const sectionIndex = sectionData.findIndex((item) => item.item_id === data.item_id);
			if (sectionIndex !== -1) {
				sectionData[sectionIndex].check_box = checkBoxValue;
			}

			// Update or push into tempArray
			const tempIndex = tempArray.findIndex((item) => item.item_id === data.item_id);
			if (tempIndex !== -1) {
				tempArray[tempIndex].option_data = optionValue;
			} else {
				const payload = {
					option_data: optionValue,
					section_id: data?.section_id,
					item_id: data.item_id
				};
				if (data?.is_discussed === 1) {
					payload.is_changed = 1;
				}
				tempArray.push(payload);
			}

			setReload(prev => !prev);
		};

		return (
			<div className='py-2 mr-5 inline-block'>
				{data?.isEdited && <div className="mr-4"><CheckCircleTwoTone /></div>}
				<Checkbox
					disabled={disable}
					checked={data.check_box === 't'}
					onChange={onChangeCheckboxValue}
					id={data.item_id}
				>
					<div dangerouslySetInnerHTML={{ __html: content_left }} />
				</Checkbox>
			</div>
		);
	};
	
	//selecting templates based on template id.
	const selectTemplate = (section) => {
		switch (section.template_id) {
			case "0":
				return template0(section.title, section.option_msg, section.scale_msg);

			case "1":
				return template1(section.content_left, section.type_left);

			case "2":
				if (section.item_id === "438") {
					return (
						<>
							{constants.ChangeJarPara}
							<p>
								We have prepared a pdf for you with your flaws and your assets. Please click the links below
								(<a onClick={() => getChangeJar(false,true)} target="_blank" title="Download this outline to create your own Change list.">Black and White pdf</a>)
								or
								(<a onClick={() => getChangeJar(true,true)} target="_blank" title="Download this outline to create your own Change list.">Colored pdf</a>) and print it out and fold them and put it in the change jar as discussed with the coach.
							</p>
						</>
					);
				} else {
					// if (section?.item_id === "699") {
					//   let newData = section?.content_left
					//     .replace("parent_name", parentName).replace("child_name", clientName);
					//   menu.push(template2(section?.title, newData, section?.option_msg, section?.scale_msg));
					// }
					return template2(section?.title, section?.content_left, section?.option_msg, section?.scale_msg)
				}

			case "3":
				if (section.template_id === "3" && section?.section_res) {
					let template3List = [];
					const idCountMap = {};
					const firstAnsweredMap = {};

					section.section_res?.forEach((el) => {
						idCountMap[el.item_id] = (idCountMap[el.item_id] || 0) + 1;
					});
					for (let index = 0; index < section?.section_res.length; index++) {
						const element = section?.section_res[index];
						const condition = section?.section_res && !(section?.section_id === "8" && section?.part_id === "2" && section?.section_type === "1") && !(section.section_id === "100" && section.part_id === "4");

						let isChecked = !!element?.dt_checked && (section?.section_id === element?.section_id);

						const duplicateCount = idCountMap[element.item_id];
						const formName = duplicateCount > 1 ? `${element.item_id}-${index}` : element.item_id;

						// Set form values appropriately
						form.setFieldsValue({ [formName]: element.client_ans });

						if (element.template_id === "36" && !element.heading) {
							continue;
						}

						//displaying summary data in sections 1, 2 and 3.
						if (section.section_id === "2") {
							if (element.title) {
								template3List.push(template2(element?.title, element?.content_left, element?.option_msg, element?.scale_msg));
							}
							template3List.push(template3(element?.heading, element, onChangeTemplete, formName, element, adminClientValuefromSession?.isAdmin ? true : element.heading === "" ? false : true, null, null, condition, onCheckboxChange, isChecked, 1));
						}
						if (section.section_id === "1" || section.section_id === "3") {
							let combinedHeading = element?.heading;

							if (section.section_id === "1") {
								let partTitle = "";

								if (element.title === 1) {
									partTitle = `<a onclick="sessionStorage.setItem('count', '${element?.part_id}');window.open('${constants.BaseUrl}/workbook-section', '_blank')">The scary ride of substance dependence</a>`;
								} else if (element.title === 2) {
									partTitle = "Alcohol"
								} else if (element.title === 3) {
									partTitle = "Substance"
								}
								if (partTitle) {
									template3List.push(template2(partTitle, element?.content_left, element?.option_msg, element?.scale_msg));
								}
								if (element.part_id !== "4") {
									const pageData = goToPageData.find((page) => page.page_no === element.part_id);
									if (pageData) {
										const cleanedTitle = pageData.page_title?.replace(/\([^)]*\)/g, "").trim();
										combinedHeading = cleanedTitle && element?.heading ? `${element?.heading} <a class='text-[14px]' onclick="sessionStorage.setItem('count', '${element?.part_id}');window.open('${constants.BaseUrl}/workbook-section', '_blank')">${cleanedTitle}</a>` : element?.heading;
									}
								}
							}
							template3List.push((element?.template_id === "30" || element?.template_id === "36") ? <> <div className='mt-2' /> {template30(element?.heading, element, adminClientValuefromSession?.isAdmin, onCheckboxChange, isChecked)} <div className='-m-5' /> </> : template3(combinedHeading, element, onChangeTemplete, formName, element, adminClientValuefromSession?.isAdmin ? true : element.heading === "" ? false : true, null, null, condition, onCheckboxChange, isChecked, 1));
						}
						if (section.section_id === "4" || section.section_id === "5" || section.section_id === "6") {
							template3List.push(template3(element?.heading, element, onChangeTemplete, formName, element, adminClientValuefromSession?.isAdmin ? true : element.heading === "" ? false : true, null, null, condition, onCheckboxChange, isChecked, 1));
						}
						//displaying summary and empty text field in section 7 and 8
						if (section.section_id === "7" || section.section_id === "8" || section.section_id === "100") {
							let tooltipValue;
							let disableTextArea;
							let isSummary = false;
							isChecked = !!element?.dt_checked;
							let updatedHeading = element?.heading;

							if (element?.heading === "" || element?.heading === null) {
								let date = element?.dt_answered ? `(${moment(element?.dt_answered).format(constants.dateformat)})` : ""
								let status = props?.location?.pathname === "/refresher-workbook" ? constants.Status2Ttip : constants.Status3Ttip
								let val = status + " " + date;
								tooltipValue = val;
								disableTextArea = true;
							} else {
								let date = element?.dt_answered ? `(${moment(element?.dt_answered).format(constants.dateformat)})` : ""
								let val = constants.Status1Ttip + " " + date;
								tooltipValue = val;
								disableTextArea = true;
							}

							//For section 7
							if (section.section_id === "7") {
								if (!firstAnsweredMap[element.item_id] && element?.heading?.trim()) {
									disableTextArea = true;
									firstAnsweredMap[element.item_id] = true;
								} else {
									disableTextArea = false;
									isSummary = 1;
								}
								// Updated the textboxes from section 2.
								if (element.section_id === "2" && element?.heading?.trim()) {
									updatedHeading = `${element.heading} (Section 2)`;
								}
							}

							//For section 8
							if (section.section_id === "8") {

								// Initialize counter for this item_id
								if (!firstAnsweredMap[element.item_id]) {
									firstAnsweredMap[element.item_id] = 1;
								} else {
									firstAnsweredMap[element.item_id]++;
								}

								const count = firstAnsweredMap[element.item_id];

								if (count === 1) {
									disableTextArea = true;
								} else if (count === 2) {
									disableTextArea = true;
								} else {
									disableTextArea = false; //false
									isSummary = "1";
								}
							}

							// For refresher - section 100
							if (section.section_id === "100") {
								disableTextArea = !(element?.section_id === "100" && !(element?.status === 3 && element?.dt_discussed));
							}
							let date = element?.dt_answered ? `(${moment(element?.dt_answered).format(constants.dateformat)})` : ""
							let labelValue = "Section " + element?.section_id + " " + date;							
							template3List.push((element?.template_id === "30" || element?.template_id === "36") ? <><div className='mt-2' />{template30(updatedHeading, element, adminClientValuefromSession?.isAdmin, onCheckboxChange, isChecked)} <div className='-m-5' /></> : template3(updatedHeading, element?.type_left, onChangeTemplete, formName, element, adminClientValuefromSession?.isAdmin ? true : disableTextArea, tooltipValue, (section.section_id === "7" || section.section_id === "8" || section.section_id === "100") && element.dt_answered ? labelValue : '', condition, onCheckboxChange, isChecked, isSummary, sectionId.toString() === "8"));
						}
					}
					return template3List;
				} else {
					const partId = Number(section?.part_id);
					const condition = section?.section_id === "2" || 
					(section?.section_id === "1" && partId >= 9 && partId <= 50) || 
					(section?.section_id === "3" && partId === 10) || 
						(
							section?.section_id === "7" &&
							["4", "7", "10", "12", "13", "14", "15", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26"].includes(section?.part_id) &&
							section?.section_type === "1"
						);
					return <Template3
						question={section.content_left}
						type_left={section.type_left}
						value={section.client_ans}
						onChange={onChangeTemplete}
						formName={section.item_id}
						tempData={section}
						isDisable={
							adminClientValuefromSession?.isAdmin
								? true
								: section?.is_disable === "t"
						}
						tooltipValue={null}
						placeholder={null}
						section_res={condition}
						onCheckboxChange={
							condition ? onCheckboxChange : onChangeCheckboxValue
						}
						isChecked={
							condition ? section?.dt_checked : section?.check_box === "t"
						}
						isSummary={null}
						DisableCheckbox={false}
						activeMicIndex={activeMicIndex}
						setActiveMicIndex={setActiveMicIndex}
						loginType={loginType}
						form={form}
					/>
				}

			case "4":
				return template4(section.content_left, section.content_right, section.type_left);

			case '5':
				return template5(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : false, onChangeCheckboxValue, onchangeTextBox);

			case '6':
				return template6(section?.content_left, section?.title, section?.video_url);

			case '7':
				return template7(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : false, onChangeTemplete)

			case '8':
				return template8(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : false, onChangeTemplete);

			case '9':
				return template9(section?.stress_chart_result);

			case '10':
				return template10(section.content_left);

			case '11':
				return template11(section?.content_left, section?.content_right, section?.type_left, section?.type_right);

			case '12':
				return template12(section.content_left);

			case '13':
				return template13(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : section.is_disable === "t" ? true : false, onChangeTemplete);

			// case '14':
			//   return template14(section.content_left);

			case '15': {
				const condition = section?.content_left === "Anger Sheet table";
				const condition2 = section?.content_left === "table code";
				return template15(section, adminClientValuefromSession?.isAdmin, tableOneColumns, tableComponents, tableOneDataSource, handleChange, handleAdd, handleActionSave, handleFutureChangeAndMyreaction, handleDelete, condition ? newSec4Option : (condition2 ? newSec6Option: newSec5Option), FutureInputRef, newOption, handleNewOptionChange, handleAddNewOption, handleAddOnSpecificIndex, handleFearChange, handleCheckboxChange, handleFearInputChange);
			}

			// case '16':
			//   return template16(section.content_left, section.type_left);

			// case '17':
			//   return template17(section.content_left, section.content_right, section.type_left);

			case '18':
				return template18(section, adminClientValuefromSession?.isAdmin ? true : false, onChangeCheckboxTable, tableCheckedValues);

			case '19':
				return template19(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : false, onChangeCheckboxValue, onchangeTextBox);

			case '20':
				return template20(sigPad, clearSignaturePad, handleSignPadVal)

			case '21':
				return luscherColorTest(boxes, handleBoxClick, section?.item_id, section?.client_ans?.length > 0 ? "test taken" : null, loginType === "1" ? adminClientValuefromSession?.client_name : null, resetLusherColor, downloadResult)

			case '22':
				return uploadFile(fileList, handleFileChange, handleRemove, beforeUpload, "age-proof")

			case '23':
				return template23(section?.content_left, section?.client_ans)

			case '24':
				return template24(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : section.is_disable === "t" ? true : false, onChangeTemplete)

			case '26':
				return template26(section.content_left, section, adminClientValuefromSession?.isAdmin ? true : section.is_disable === "t" ? true : false, onChangeTemplete)

			case '28':
				return template28(section?.client_ans)

			case '29':
				return template29(section?.content_left, section, (adminClientValuefromSession?.isAdmin || section?.section_id === "0" || ( section?.is_current_section === "0" && ["1798", "2336", "817"].includes(section?.item_id) )), onCheckboxChange, onchangeTextBox);

			case '30':
				return template30(section?.content_left, section, adminClientValuefromSession?.isAdmin, onCheckboxChange, !!section?.dt_checked, section?.is_summary === "2");

			case '31':
				return templateVideoStreaming(`${constants.ApiUrl}/get-video/${section?.content_left}/index.m3u8`);

			case '32':
				return templateYouTube(section?.video1_link, section?.video2_link, section?.video3_link, section?.video1_title, section?.video2_title, section?.video3_title);
			case '33':
				return <div className="container mx-auto">
					<div className='my-8'>
						<div>
							{section?.content_left ? templeteJarOutline(section?.content_left, isColored, onChangeSwitchButton): null}
						</div>
					</div>
				</div>
			case '34':
				return templateGradtitude(isColoredGratitudeJar, onChangeGratitudeSwitchButton, section?.content_left, section?.content_right)

			case '35':
				return checkboxGrid(section?.content_left, section, adminClientValuefromSession?.isAdmin ? true : section?.is_disable === "t" ? true : false)

			case '36':
				return template36(section?.content_left, section, adminClientValuefromSession?.isAdmin ? true : (section?.check_box === "t" && section?.is_current_section === "0"), onChangeTemplete)
			
			case '37':
				return template37(section, handleAddFlaws);

			case '38':
				return <a onClick={()=>downloadResult(section)}>{section?.title}</a>

			case '39':
				return templateBucketList(section, adminClientValuefromSession?.isAdmin, tableComponents, tableOneDataSource, handleAddBucket, handleActionSave, handleDelete);

			case "40":
				return template40(section.content_left, section,  adminClientValuefromSession?.isAdmin ? true : section.is_disable === "t" ? true : false, onchangeTextBox);

			default:
				return null;
		}
	};

	const handleAddFlaws = (payload) => {
		return fetchApi(`/add-answers`, "post", payload).then((res) => {
			if (res?.code === 200) {
				fetchWorkbookSections(sectionId, counter, otherPathname);
				message.success(res.message);
			} else {
				message.error(res.message);
			}
			return res?.code;
		});
	};
	const handleGamblingAddiction = () => {
		let item_id_option1 = sectionId == 0 ? "1658" : "1036";
		let counterStep = sectionId == 0 ? 2 : 3;
		let findIndex = sectionData?.findIndex((val) => val.item_id === item_id_option1);
		if (findIndex > -1) {
			//Gambling validation.
			let checkGamblingOptionAns = checkGamblingOption(sectionData);
			if (checkGamblingOptionAns) {
				inCreamentCounter(counter, counterStep);
				sessionStorage.setItem('is_gambling_addiction', counterStep);
			} else {
				sessionStorage.setItem('is_gambling_addiction', 1);
				inCreamentCounter(counter, 1);
			}
		} else {
			sessionStorage.removeItem('is_gambling_addiction', 1);
			inCreamentCounter(counter, 1);
		}
	};

	//increamenting counter value 
	const inCreamentCounter = (count, length) => {
		setCounter(count + length);
		sessionStorage.setItem('count', count + length);
	};

	//decreamenting counter value 
	const decreamentCounter = (count, length) => {
		setCounter(count - length);
		sessionStorage.setItem('count', count - length);
	};

	//function onclick next;
	const handleNextPart = () => {
		if (loginType === "0") {
			handleEditableTableClientData();
			handleCheckboxTableClientData();
			handleValidate("Next");
		} else {
			if (clientData.length > 0 && !isTestsPage) {
				addAnswers(clientData)
			}
			!isTestsPage ? handleGamblingAddiction(): inCreamentCounter(counter, 1);;
		}
		document.getElementById('top').scrollIntoView({ behavior: "smooth" });
	};

	//function to validate form fields.
	const handleValidate = async (type, payload = null) => {
		try {
			const values = await form.validateFields();
			if (type === "Submit") {
				if (clientData.length > 0) {
					addAnswers(clientData)
						.then((res) => {
							// Handle success
							if (res?.code === 200) {
								updateSection(clientId, "0", "2", sectionId);
								if (enableTill !== sectionLength) {
									callSaveandCloseApi(clientId, payload, null);
								}
							} else {
								message.error(res?.message);
							}
						})
						.catch((error) => {
							console.error('Error:', error);
							// Handle error
							message.error(error)
						});
				} else {
					const findIndex = sectionData.findIndex((val) => val?.template_id === "7");
					if (findIndex > -1 && sectionData[findIndex].client_ans === null) {
						message.error(constants.ValidationMessage);
					} else {
						updateSection(clientId, "0", "2", sectionId);
						if (enableTill !== sectionLength) {
							callSaveandCloseApi(clientId, payload, null);
						}
					}
				}

			}
			else if (type === "SubmitSectionZero") {
				if(esignValue){
					handleStoreSignature();
				}else{
					if (clientData.length > 0) {
						addAnswers(clientData, null);
					}
					let findIndex = sectionData?.findIndex((val) => val.item_id === "1658");
					if (findIndex > -1) {
						handleGamblingAddiction();
					}
					if(counter == enableTill){
						if (props?.location?.pathname === "/workbook-tests") {
							handleStoreSignature();
						} else {
							handleStoreSignature("goto-selfassessment");
						}
					}
				}
			}
			else {
				if (clientData.length > 0) {
					// api call add answers
					addAnswers();
				} else {
					//lushercolor validation
					const findIndex = sectionData.findIndex((val) => val?.template_id === "21");
					if (findIndex > -1 && sectionData[findIndex].client_ans === null) {
						message.error("Please Answer the Lusher color test.");
					} else {
						handleGamblingAddiction();
					}
				}
			}
			// You can call onFinish or submit the form if validation succeeds
		} catch (errorInfo) {
			console.log('Validation failed:', errorInfo);
			// Handle validation errors or display error messages
			message.error('Please fill in all required fields.');
		}
	};
	//calling storeSignature
	const handleStoreSignature = (selfassessment = null) => {
		const formPaths = ["/workbook-tests", "/coaching-form", "/commitment-form", "/suicidal-form"];
		const currentPath = props?.location?.pathname;

		let payload = {
			client_id: getCookie(COOKIE.ClientId),
			plan_id: (planId === "null" || planId === "" || planId === undefined || planId === "undefined") ? null : planId,
		}
		if (selfassessment !== null) {
			payload.form_type = "5";
		} else {
			payload.image = esignValue;
			const htmlContent = getHtmlCode();

			// Determine form_type based on path
			switch (currentPath) {
				case "/coaching-form":

					payload.form_type = "1";
					payload.pdfValue = htmlContent;
					break;

				case "/suicidal-form":
					payload.form_type = "2";
					payload.client_ans = clientData;
					break;

				case "/workbook-tests":
					payload.form_type = "5";
					break;

				case "/commitment-form":
				default:
					payload.form_type = "4";
					break;
			}
		}
		sessionStorage.removeItem("is_gambling_addiction");
		fetchApi(`/store-signature`, "post", payload).then((res) => {
			if (res?.code === 200) {
				if (selfassessment) {
					history.push({ pathname: "/self-assessment-summary" });
				} else if (formPaths.includes(currentPath)) {
					history.push({ pathname: "/dashboard" });
				} else {
					inCreamentCounter(counter, 1);
					setEsignValue("");
				}
			} else {
				message.error(res?.message);
			}
		})
	};
	//calling add answer api
	const addAnswers = (type = null, showmessage = null, discussed = false) => {
		return new Promise((resolve, reject) => {
			let payload = {
				client_id: clientId,
				client_data: type !== null ? type : clientData,
				plan_id: (planId === "null" || planId === "" || planId === undefined || planId === "undefined") ? null : planId,
			};
			if(discussed){
				payload.section_id = String(sectionId);
				payload.part_id = counter;
				payload.is_admin =1;
				if (counter >= lastDiscussedPartId) {
					payload.last_discussed_part_id = counter;
				}
			}
			fetchApi(`/add-answers`, "post", payload)
				.then((res) => {
					if (res?.code === 200) {
						if (type === null) {
							//gambling validation
							let counterStep = sectionId == 0 ? 2 : 3;
							let item_id_option1 = sectionId == 0 ? "1658" : "1036"; 
							let findIndex = sectionData.findIndex((val) => val.item_id === item_id_option1);
							if (findIndex > -1) {
								let checkGamblingOptionAns = checkGamblingOption(sectionData);
								if (checkGamblingOptionAns) {
									inCreamentCounter(counter, 3);
									sessionStorage.setItem('is_gambling_addiction', counterStep);
								} else {
									sessionStorage.setItem('is_gambling_addiction', 1);
									inCreamentCounter(counter, 1);
								}
							} else {
								sessionStorage.removeItem('is_gambling_addiction', 1);
								inCreamentCounter(counter, 1);
							}
						}
						
						if (showmessage !== null) message.success(res?.message);
						setClientData([]);
					} else {
						message.error(res?.message);
						setClientData([]);
					}
					resolve(res); // Resolve with the status code
				})
				.catch((error) => {
					reject(error); // Reject with the error if fetchApi fails
				});
		});
	};

	//modal related functions
	const getModal = () => {
		//popup for esign message
		if (sectionId === "0") {
			return popupMessage(
				null,
				// esignMessageModalOpen,
				// handleEsignMessageModalOk,
				// counter === constants.SectionZeroPart.coachingAgreementpagetwo ? constants.EsignPopupMessageConsentForm : constants.EsignPopupMessage,
				null,
				null,
				null
			);
		} else {
			return popupMessage(
				constants.WorkbookHeaderText,
				instructionModalOpen,
				handleInstructionmodalOk,
				/* token === "refresher-workbook" ? constants.WorkbookInstructionsTextRefresher :  */constants.WorkbookInstructionsText,
				/* token === "refresher-workbook" ? null : */ `${sectionId}.`,
				constants.WorkbookInstructionsText2,
				constants.complete4
			);
		}
	};

	//function onclick previous;
	const handlePreviousPart = async () => {
		const isWorkbookSection = props?.location?.pathname === "/workbook-section";
	
		if (isWorkbookSection) {
			if (loginType === "0") {
				handleEditableTableClientData();
				handleCheckboxTableClientData();
	
				if (clientData?.length > 0) {
					await addAnswers(clientData);
				}
			} else {
				if (clientData?.length > 0) {
					await addAnswers(clientData);
				}
			}
		}
	
		let checkGamblingAddiction = sessionStorage.getItem('is_gambling_addiction');
		if (checkGamblingAddiction && !isTestsPage) {
			decreamentCounter(counter, checkGamblingAddiction)
		} else {
			decreamentCounter(counter, 1)
		}
	};

	//Instruction modal
	const showInstructionModal = () => {
		setInstructionModalOpen(true);
	};
	const handleInstructionmodalOk = () => {
		setInstructionModalOpen(false);
	};

	//handle Submit
	const handleSubmit = () => {
		if (loginType === "0") {
			let save_and_close_payload = {
				section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
				is_admin: loginType,
				part_id: counter
			}
			// if(clientData.length>0){
			// 	handleValidate("Submit",save_and_close_payload);
			// }else{
			// 	updateSection(clientId,"0","2",sectionId);
			// 	if(enableTill !== sectionLength){
			// 		callSaveandCloseApi(clientId,save_and_close_payload,null);
			// 	}
			// }
			if (parseInt(sectionId) === 0) {
				handleValidate("SubmitSectionZero");				
			} else {
				handleEditableTableClientData();
				handleCheckboxTableClientData();
				handleValidate("Submit", save_and_close_payload);
			}
		} else {
			getDiscussionValue();
			if (clientData.length) {
				addAnswers(clientData);
			}
			updateSection(clientId, "1", sectionLength === enableTill ? "2" : "5", sectionId);
		}
	};

	const updateSection = (client_id, is_admin, flag, section_id) => {
		setLoader(true);
		let payload = {
			is_admin: is_admin,
			flag: flag,
			section_id: section_id
		}
		fetchAdminApi(`/update-client-sections/${client_id}`, "put", payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				if (is_admin === "1") {
					if (enableTill === sectionLength) {
						history.push("/dashboard");
					} else {
						fetchWorkbookSections(sectionId, counter);
					}
				} else {
					let prop_state = null;
					if (enableTill === sectionLength) {
						prop_state = {
							isPopUpMessage: true,
							sectionId: sectionId
						};
					}
					history.push({
						pathname: "/dashboard",
						state: prop_state
					});
				}
				message.success(res?.message);
			} else {
				message.error(res.message);
				setLoader(false);
			}
		})
	};

	const getDiscussionValue = () => {
		if (props?.location?.state?.status !== "3" || adminClientValuefromSession?.status !== "3") {
			let noClientAns = false;
			const clientDataMap = new Map(clientData.map(item => [item.item_id, item]));
			// Merging sectionData with clientData
			const mergedData = sectionData.map((item) => {
				const clientItem = clientDataMap.get(item.item_id);

				if (clientItem) {
					noClientAns = true;

					// Merge clientData and sectionData, giving priority to clientData's is_checked			
					return {
						...clientItem,
						is_admin: "1",
						part_id: counter,
						// Preserve dt_checked value if it exists
						is_checked: clientItem?.is_checked,
					};
				} else if (item.client_ans !== null) {
					noClientAns = true;
					return {
						section_id: item.section_id,
						item_id: item.item_id,
						is_admin: "1",
						part_id: counter,
						// Preserve dt_checked value if it exists
						is_checked: item.dt_checked ? "1" : "0",
					};
				}
				return null; // Skip items without client_ans
			}).filter(Boolean); // Remove null values
			if (!noClientAns) {
				let itemId;
				if(sectionData.length > 0){
					itemId = sectionData[0].item_id;
				}	
				if (lastDiscussedPartId) {
					if (parseInt(lastDiscussedPartId) < counter) {
						clientData.push({
							section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
							is_admin: "1",
							part_id: counter,
							item_id: itemId,
						});
					}
				} else {
					clientData.push({
						section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
						is_admin: "1",
						part_id: counter,
						item_id: itemId,
					});
				}
			}

			// Clear and update clientData with mergedData
			if (mergedData.length > 0) {
				clientData.length = 0;
				clientData.push(...mergedData);
			}

			// Handle section_res
			sectionData?.forEach((item) => {
				if (item.section_res) {
					const mergedResData = item.section_res.map((nestedItem) => {
						const clientItem = clientDataMap.get(nestedItem.item_id);
						if (clientItem) {
							return {
								section_id: nestedItem.section_id,
								item_id: nestedItem.item_id,
								is_admin: "1",
								part_id: counter,
								// Preserve dt_checked value if it exists
								is_checked: clientItem?.is_checked,
							};
						}
						// else if (nestedItem.client_ans !== null) {
						// 	return {
						// 		section_id: nestedItem.section_id,
						// 		item_id: nestedItem.item_id,
						// 		is_admin: "1",
						// 		part_id: counter,
						// 		// Preserve dt_checked value if it exists
						// 		is_checked: nestedItem.dt_checked ? "1" : "0",
						// 	};
						// }
						return null; // Skip items without client_ans
					}).filter(Boolean); // Remove null values

					// Update clientData with mergedResData
					if (mergedResData.length > 0) {
						clientData.push(...mergedResData);  // No need to clear here
					}
				}
			});
		}
	};

	const handleAdminDiscussed = () => {
		getDiscussionValue();
		if (clientData.length > 0) {
			addAnswers(null,null,true);
		} else {
			inCreamentCounter(counter, 1);
		}
		// if(displayGamblingValidateMessage){
		// 	setCounter(counter + 3);
		// 	sessionStorage.setItem('count', counter + 3);
		// }else{
		// 	setCounter(counter + 1);
		// 	sessionStorage.setItem('count', counter + 1);
		// }
		document.getElementById('top').scrollIntoView({ behavior: "smooth" });
	};

	//function to save and close
	const handleSaveAndClose = () => {
		let client_id = null;
		let state = null;
		if (adminClientValuefromSession?.clientId) {
			client_id = adminClientValuefromSession?.clientId;
			state = {
				isAdmin: true,
				clientId: adminClientValuefromSession?.clientId,
				client_name: adminClientValuefromSession?.client_name,
				client_serial_number: adminClientValuefromSession?.client_serial_number
			};
		} else {
			client_id = getCookie(COOKIE.ClientId);
		}
		let payload = {
			section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
			is_admin: loginType,
			part_id: counter
		};
		if (loginType === "0") {
			handleEditableTableClientData();
			handleCheckboxTableClientData();
			if (clientData.length > 0) {
				addAnswers(clientData)
					.then((res) => {
						// Handle success
						if (res?.code === 200) {
							callSaveandCloseApi(client_id, payload, state);
						} else {
							message.error(res?.message);
						}
					})
					.catch((error) => {
						console.error('Error:', error);
						// Handle error
						message.error(error)
					});
			} else {
				callSaveandCloseApi(client_id, payload, state);
			}
		} else {
			if (clientData.length > 0) {
				addAnswers(clientData)
					.then((res) => {
						// Handle success
						if (res?.code === 200) {
							callSaveandCloseApi(client_id, payload, state);
						} else {
							message.error(res?.message);
						}
					})
					.catch((error) => {
						console.error('Error:', error);
						// Handle error
						message.error(error)
					});
			} else {
				callSaveandCloseApi(client_id, payload, state);
			}
			if (noteValue) {
				message.error(constants.notesVM);
			} else {
				callSaveandCloseApi(client_id, payload, state);
			}
		}
	};

	const callSaveandCloseApi = (client_id, payload, state) => {
		setLoader(true);
		fetchApi(`/save-and-close/${client_id}`, "put", payload).then((res) => {
			if (res && res.code === 200) {
				setLoader(false);
				history.push({
					pathname: "/dashboard",
					state: state
				});
			} else {
				setLoader(false);
				message.error(res.message);
			}
		});
	};

	const displayResumeButton = () => {
		if (loginType === "0") {
			if (isResume?.client_resume && counter === 1) {
				return <Button className='bg-sky-800 text-white uppercase' onClick={handleResume}>{constants.Resume}</Button>;
			}
		} else {
			if (isResume?.admin_resume && counter === 1) {
				return <Button className='bg-sky-800 text-white uppercase' onClick={handleResume}>{constants.Resume}</Button>;
			}
		}
	};

	const handleResume = () => {
		if (loginType === "0") {
			if (isResume.client_resume !== null) {
				inCreamentCounter(0, parseInt(isResume.client_resume));
			}
		} else {
			if (isResume.admin_resume !== null) {
				inCreamentCounter(0, parseInt(isResume.admin_resume));
			}
		}
	};

	const handleClose = () => {
		let noteValue = null //check when you integrate add notes 
		if (noteValue) {
			message.error(constants.notesVM);
		} else {
			history.push({ pathname: "/dashboard" });
		}
	};

	const nextBtn = ({ additionalClass = '', size = '' }) => (
		(counter < enableTill && !displayGamblingValidateMessage) ||
		(counter < enableTill && displayGamblingValidateMessage && isGamblingAnswered) ||
		(loginType !== "0" && counter < sectionLength) ||
		(isTestsPage && counter !== sectionLength) ?
			<Button
				className={`bg-sky-800 text-white uppercase ${additionalClass}`}
				size={size}
				disabled={loader}
				onClick={handleNextPart}
			>
				{constants.Next}
			</Button> :
			null
	);

	const previousBtn = ({ additionalClass = '', size = '' }) => (
		(sectionId == 0 && counter === 3 && !isTestsPage) ? null :
		(counter >= 2) ?
			<Button
				className={`bg-sky-800 text-white uppercase ${additionalClass}`}
				size={size}
				disabled={loader}
				onClick={handlePreviousPart}
			>
				{constants.Previous}
			</Button> :
			null
	);

	const routeToListNotes = () => {
		window.open(constants.BaseUrl + "/notes");
	};

	//notes functions start here
	const getForm = (formType) => {
		setNoteTypeValue(formType);
		setLoader(true);
		let payload = {
			note_type: formType,
			client_id: adminClientValuefromSession?.clientId,
		};
		fetchAdminApi("/notes", 'post', payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				setNoteValue(res?.data?.data);
				if (res?.data?.is_note_answered === 1) {
					setIsNoteAnswered(true);
				} else {
					setIsNoteAnswered(false);
				}
				// setNoteTitle(res?.data?.date);
			} else {
				setNoteValue([]);
				// setNoteTitle("");
				setLoader(false);
			}
		});
	};

	const addNotes = () => {
		document.getElementById('top').scrollIntoView({ behavior: "smooth" });
		getForm(noteTypeValue);
		setnotesVisible(true);
	};

	const hideModal = () => {
		setNoteValue(null);
		setNoteTypeValue("0");
		setnotesVisible(false);
		setNoteFollowUp(false);
		setSessionChecked(false);
	};

	const onchangeNoteValue = (e, index) => {
		setNoteValue(prev => {
			const updated = [...prev];
			updated[index] = e;
			return updated;
		});
	};

	const createNote = (type) => {
		let admin_id = getCookie(COOKIE.ClientId);
		let assessmentText = '';
		if (noteValue[1]) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> " + noteValue[1];
		} else if (assessmentBehavior?.length > 0) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> ";
		}

		let payload = {
			client_id: adminClientValuefromSession?.clientId,
			notes_content: noteValue[0] ? "<b><u>DATA:</u></b>" + " " + noteValue[0] : "",
			notes_assesment: assessmentText,
			notes_plan: noteValue[2] ? "<b><u>PLAN:</u></b>" + " " + noteValue[2] : "",
			section_id: props?.location?.pathname === "/refresher-workbook" ? "100" : sectionId,
			admin_id: admin_id,
			notes_type: noteTypeValue,
			dt_created: `${noteDate.year}-${noteDate.month}-${noteDate?.date}`
		};
		if (noteTypeValue === "0") {
			const clientName = adminClientValuefromSession?.client_name || "Client";

			const behaviorSentence = assessmentBehavior?.length > 0
				? `<h3>${clientName} ${assessmentBehavior?.join(', ')}.</h3>`
				: '';

			payload.notes_assesment_behaviour = behaviorSentence;
			payload.answers = {
				...(payload.answers || {}),
				follow_up: notefollowUp ? 1 : 0,
				assessment_behavior: assessmentBehavior
			};
		}
		if (sessionChecked === true) {
			payload.session_checked = sessionChecked;
		}
		if (type === "esign") {
			payload.signed_by = admin_id;
		}
		if (noteValue !== null) {
			fetchAdminApi(`/add-notes`, "post", payload).then((res) => {
				if (res && res.code && res.code === 200) {
					hideModal();
					setNoteDate({
						...noteDate,
						date: current.getDate(),
						month: String(current.getMonth() + 1).padStart(2, '0'),
						year: current.getFullYear()
					});
					setAssessmentBehavior([]);
					message.success(res.message);
				} else {
					message.error(res.message);
				}
			});
		}
	};
	//date of notes date onchange
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date: value
		});
	};

	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month: value
		});
	};

	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year: value
		});
	};
	const onFollowUpChange = (checked) => {
		setNoteFollowUp(checked);

		const firstName = adminClientValuefromSession?.client_name

		if (checked) {
			onchangeNoteValue(constants.FollowUpData1 + `${firstName || "Client"}` + constants.FollowUpData2, 0);
			onchangeNoteValue(constants.FollowUpAssessment, 1);
			onchangeNoteValue(constants.FollowUpPlan, 2);
		} else {
			onchangeNoteValue("", 0);
			onchangeNoteValue("", 1);
			onchangeNoteValue("", 2);
		}
	};
	//notes functions ends here.

	//redirect to editclient page.
	const redirectToEditProfile = () => {
		window.open(constants.BaseUrl + "/edit-client");
	};

	const getMedicalFormData = () => {
		sessionStorage.clear();
		let payload = {
			clientId: getCookie(COOKIE.ClientId),
			client_name: getCookie(COOKIE.FirstName) + " " + getCookie(COOKIE.LastName),
			is_medical_info: true,
			count: counter
		};
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/medical-info");
	};

	const getChangeJar = (isColored,newtab) => {
		let payload = {
			color: isColored,
		};
		localStorage.setItem("colorValue", JSON.stringify(payload));
		if(newtab){
			window.open(constants.BaseUrl + "/change-jar");
		}
	};

	// Filter `option.label` match the user type `input`
	const selectFilterOption = (input, option) => {
		return option?.children?.props?.children[2]?.props?.title?.toLowerCase().indexOf(input?.toLowerCase()) > -1 && option?.children?.props?.children[2]?.props?.title?.toLowerCase().indexOf(input?.toLowerCase()) < 1;
	};

	const handleGoToPage = (page_no) => {
		if (page_no !== undefined) {
			let findIndex = goToPageData.findIndex((val) => val.page_no === page_no);
			if (loginType !== "0") {
				inCreamentCounter(0, parseInt(page_no))
			} else {
				if (goToPageData[findIndex].is_enabled) {
					inCreamentCounter(0, parseInt(page_no));
				}
			}
		}
	};

	const checkFamilyCodependencyOption = (userData, pageTitle) => {
		const isFamilyScreening = pageTitle === "Quick 10 Item Family Screening";

		const isCodependencyScreening = pageTitle === "Codependency Screening";

		if (!isFamilyScreening && !isCodependencyScreening) {
			return "";
		}

		// Count Yes answers for template 7 only
		const template7Questions = userData?.filter(
			(item) => Number(item?.template_id) === 7
		) || [];

		const allAnswered =
			template7Questions.length > 0 &&
			template7Questions.every(
				(item) =>
					item?.client_ans !== null &&
					item?.client_ans !== undefined &&
					item?.client_ans !== ""
			);

		if (!allAnswered) {
			return "";
		}

		const yesCount = template7Questions.filter(
			(item) => String(item?.client_ans) === "1"
		).length;

		if (isFamilyScreening) {
			if (yesCount <= 2) {
				return "Your result - Minimal reported family impact.";
			}

			if (yesCount <= 4) {
				return "Your result - Mild family impact; education and support may be beneficial.";
			}

			if (yesCount <= 7) {
				return "Your result - Moderate family impact; consider family recovery support and coaching.";
			}

			return "Your result - Significant family impact; a comprehensive family recovery plan is recommended.";
		}

		// Codependency Screening
		if (yesCount <= 4) {
			return "Your result - Few codependent traits identified.";
		}

		if (yesCount <= 9) {
			return "Your result - Mild codependent patterns; increased awareness may be helpful.";
		}

		if (yesCount <= 14) {
			return "Your result - Moderate codependent traits affecting relationships and well-being.";
		}

		return "Your result - Significant codependent patterns; further exploration and recovery support recommended.";
	};

	const checkGamblingOption = (userData) => {
		let item_id_option1 = sectionId == 0 ? "1657" : "1036"; 
		let item_id_option2 = sectionId == 0 ? "1658" : "1048"; 
		let option1 = userData?.findIndex((item) => item?.item_id ===  item_id_option1);//item id of option1 of gambling
		let option2 = userData?.findIndex((item) => item?.item_id === item_id_option2);//item id of option2 of gambling
		let result;
		if (userData?.[option1]?.option_data === "2" && userData?.[option2]?.option_data === "2" || userData?.[option1]?.client_ans === "2" && userData?.[option2]?.client_ans === "2") {
			result = true;
		} else {
			result = false;
		}
		return result;
	};
	const showHideNextButton = (data) => {
		let item_id_option1 = sectionId == 0 ? "1657" : "1036"; 
		let item_id_option2 = sectionId == 0 ? "1658" : "1048";
		let option1 = data?.findIndex((item) => item?.item_id ===  item_id_option1);//item id of option1 of gambling
		let option2 = data?.findIndex((item) => item?.item_id === item_id_option2);//item id of option2 of gambling
		if(option1 > -1 || option2 > -1){
			if (data?.[option1]?.client_ans && data?.[option2]?.client_ans) {
				return true;
			}else{
				return false;
			}
		}else{
			return true;
		}
	};

	function capitalizeFirstLetter(str) {
		return str?.toLowerCase()?.replace(/(?:^|\s)\S/g, function (a) {
			return a?.toUpperCase();
		});
	};

	const onChangeSwitchButton = (ischecked) => {
        setIsColored(ischecked);
		getChangeJar(ischecked,false);
    };

	const onChangeGratitudeSwitchButton = (ischecked) => {
        setIsColoredGratitudeJar(ischecked);
    };

	const onSessionChange = (value) => {
		setSessionChecked(value);
	};

	// Section 4, Page 4 - Displaying checkbox items in 3 rows. 

	const findTargetIndex = (sectionData) => {
		if (!Array.isArray(sectionData)) return -1;

		return sectionData.findIndex(
			(sec) => sec?.section_id === "4" && sec?.part_id === "4" && sec?.title === "PEOPLE"
		);
	};	

	const getItemsAfterTarget = (sectionData) => {
		const targetIndex = findTargetIndex(sectionData);

		if (targetIndex !== -1) {
			return sectionData.slice(targetIndex + 1);
		} else {
			return []; // return an empty array
		}
	};

	const getItemsBeforeTarget = (sectionData) => {
		const targetIndex = findTargetIndex(sectionData);

		if (targetIndex !== -1) {
			return sectionData.slice(0, targetIndex);
		} else {
			return []; // return an empty array
		}
	};

	const itemsBeforeTarget = getItemsBeforeTarget(sectionData);
	const itemsAfterTarget = getItemsAfterTarget(sectionData);
	// Sections 1, 3, and 7 - custom page order
	const finalSections = (() => {
		const priorityItems = [];
		const normalItems = [];

		sectionData?.forEach((sec) => {

			const isTemplate36Priority =
				sec?.template_id === "36" &&
				["1", "3", "7"].includes(sec?.section_id) &&
				sec?.check_box === "t" &&
				sec?.is_current_section === "0";

			const isSpecialTemplate29Priority =
				sec?.template_id === "29" &&
				sec?.is_current_section === "0" &&
				["1798", "2336", "817"].includes(sec?.item_id);

			const isPriority =
				isTemplate36Priority ||
				isSpecialTemplate29Priority;

			if (
				sec?.template_id === "36" ||
				sec?.template_id === "29"
			) {
				if (isPriority) {
					priorityItems.push(sec);
				} else {
					normalItems.push(sec);
				}
			}
		});

		const reorderedItems = [
			...priorityItems,
			...normalItems
		];

		let cursor = 0;

		return sectionData?.map((sec) => {

			if (
				sec?.template_id === "36" ||
				sec?.template_id === "29"
			) {
				return reorderedItems[cursor++];
			}

			return sec;
		});
	})();
	const handleAssessmentBehaviorChange = (value) => {
		setAssessmentBehavior(value);
	}

	// For Facilitaor - admin layout on the left side.
	const isWorkbookSectionPath = (otherPathname === "/workbook-section" && sectionData?.length > 0 );
	const hasFacilitatorData = facilitatorData?.length > 0;
	const leftContent = (hasFacilitatorData ?
		<div>
			{facilitatorData?.map((section) => (
				<span key={section.item_id} className="disabled-dark font-large">
					{renderTemplate(section)}
				</span>
			))}
		</div> : null
	);

	const getSectionLabel = (sectionId, counter) => {
		const secId = parseInt(sectionId);
		const labelNumber = secId % 100;
		const isWeek = secId >= 200;

		if (secId === 0) {
			return secZeroSubTitle?.[counter - 1]?.page_title;
		}
		if (secId === 100) {
			return constants.RefresherWorkSheet;
		}
		if (isWeek) {
			return `Week ${labelNumber}`;
		}
		return `${constants.sec} #${secId}`;
	};

	return (
		<Spin spinning={loader} size="large">
			<div className='mb-5'>
				<div className='bg-amber-300 text-lg font-semibold p-3 flex flex-wrap items-center justify-center'>
					{constants.Subtitle}
					{!isTestsPage && <span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">{getSectionLabel(sectionId, counter)}{sectionId !== 0 && <span className="ml-3">Page <span>#{counter}</span></span>}</span>}
				</div>
				{
					loginType !== "0" ? (
						<div className='bg-amber-100 text-base font-semibold p-2 mb-2'>
							<div className="container mx-auto flex justify-between items-center">
								<Space size={'small'} wrap direction="vertical">
									<span onClick={() => {
										history.push({
											pathname: "/edit-client",
											state: { client_id: adminClientValuefromSession?.clientId }
										});
									}} className="font-semibold text-base text-black cursor-pointer">{constants.AdminWorkbook} - {`${adminClientValuefromSession?.client_name ? adminClientValuefromSession?.client_name + " " : ""} (#${adminClientValuefromSession?.client_serial_number ? adminClientValuefromSession?.client_serial_number : ""})`}</span>
									<Space wrap>
										<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={() => isTestsPage ? history.push("/pre-assessment-intake") : history.goBack()}>{constants.BackBtn}</Button>
										<Space className='mx-4' wrap>
											{
												previousBtn({ additionalClass: 'text-xs font-semibold', size: 'small' })
											}
											{
												nextBtn({ additionalClass: 'text-xs font-semibold', size: 'small' })
											}
										</Space>
										{!isTestsPage && <Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={routeToListNotes}>{constants.ViewNotes}</Button>}
										{
											sectionId !== 0 ?
												!isTestsPage && <Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={addNotes}>{constants.AddNote}</Button>
												: null
										}
										{
											sectionId !== "0" ?
												<>
													<Space className='mx-3'>
														<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={redirectToEditProfile}>Profile</Button>
													</Space>
												</> :
												null
										}
										{/* go to page dropdown condition */}
										{
											sectionId > 0 ?
												<Select
													placeholder={constants.GoToPage}
													className='sm:w-[350px] w-[250px] max-w-full'
													showSearch
													allowClear
													filterOption={selectFilterOption}
													onChange={handleGoToPage}
												>
													{goToPageData &&
														goToPageData.map((goToPageData) => {
															return <Select.Option key={goToPageData.page_no} value={goToPageData.page_no}>
																<Space>
																	{goToPageData?.is_edited ? <EditOutlined className='min-w-[15px]' /> : <div className='w-[15px]'></div>}
																	<span className='w-6 text-right block m-auto'>{goToPageData.page_no} : </span>
																	<p className="text-ellipsis overflow-hidden max-w-[240px]" title={capitalizeFirstLetter(`${goToPageData.page_title}`)}>{capitalizeFirstLetter(`${goToPageData.page_title}`)}</p>
																	{goToPageData?.is_enabled ? <UnlockOutlined className='min-w-[15px]' /> : <LockOutlined className='min-w-[15px]' />}
																</Space>
															</Select.Option>
														})}
												</Select> :
												null
										}
									</Space>
								</Space>
							</div>
						</div>
					) :
						<div className=' bg-amber-100 p-2 mb-2'>
							<div className='container mx-auto '>
								<Space className={newUser && 'flex justify-between'} wrap>
									{
										previousBtn({ additionalClass: 'text-xs font-semibold', size: 'small' })
									}
									{
										nextBtn({ additionalClass: 'text-xs font-semibold', size: 'small' })
									}
									{
										enableTill === counter && loginType === "0" || (displayGamblingValidateMessage && !isGamblingAnswered) ?
											<Button size='small' className={'bg-sky-800 text-white uppercase'} disabled={loader ? true : false} onClick={handleSubmit}>{constants.Submit}</Button> :
											null
									}
									{
										sectionId > 0 ?
											<Select
												placeholder={constants.GoToPage}
												className='!w-[350px]'
												showSearch
												allowClear
												filterOption={selectFilterOption}
												onChange={handleGoToPage}
											>
												{goToPageData &&
													goToPageData.map((goToPageData) => {
														return <Select.Option key={goToPageData.page_no} value={goToPageData.page_no}>
															<Space>
																{goToPageData?.is_edited ? <EditOutlined className='min-w-[15px]' /> : <div className='w-[15px]'></div>}
																<span className='w-6 text-right block m-auto'>{goToPageData.page_no} : </span>
																<p className="text-ellipsis overflow-hidden max-w-[240px]" title={capitalizeFirstLetter(`${goToPageData.page_title}`)}>{capitalizeFirstLetter(`${goToPageData.page_title}`)}</p>
																{goToPageData?.is_enabled ? <UnlockOutlined className='min-w-[15px]' /> : <LockOutlined className='min-w-[15px]' />}
															</Space>
														</Select.Option>
													})}
											</Select> :
											null
									}
									{newUser && (<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={() => { history.push({ pathname: "/my-profile", state: { counter: counter } }); }}>{constants.MyProfileText}</Button>)}
									{sectionId === 0 && <Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={getMedicalFormData}>{constants.ReleaseForm}</Button>}
								</Space>
							</div>
						</div>
				}

				<div className={`${isWorkbookSectionPath ? "mt-16" : "mt-4"} container mx-auto px-2`}>
					<Form layout='vertical' form={form}>

						{/* ── Outer book wrapper (provides the "stacked pages" depth) ── */}
						<div className={`${isWorkbookSectionPath ? "relative" : ""}`}>

							{isWorkbookSectionPath && <>
								{/* === Stacked pages peeking out at the bottom === */}
								<div className="absolute bottom-[-18px] left-[28px] right-[28px] h-[40px] bg-[#e8d9a0] rotate-[-1.5deg] rounded-lg z-0" />
								<div className="absolute bottom-[-13px] left-[22px] right-[22px] h-[36px] bg-[#edd98c] rotate-[1deg] rounded-lg z-[1]" />
								<div className="absolute bottom-[-8px] left-[16px] right-[16px] h-[32px] bg-[#f5e9b2] rotate-[-0.5deg] rounded-lg z-[2]" />
								<div className="absolute bottom-[-4px] left-[10px] right-[10px] h-[28px] bg-[#fef3c7] rotate-[0.3deg] rounded-lg z-[3]" />
								<div className="absolute bottom-[-1px] left-[5px] right-[5px] h-[20px] bg-[#fde68a] rounded-lg z-[4]" />
								<div className="absolute top-[-14px] left-[30px] right-[30px] h-[30px] bg-[#f5e9b2] rotate-[1deg] rounded-lg z-0" />
								<div className="absolute top-[-9px] left-[20px] right-[20px] h-[26px] bg-[#fde68a] rotate-[-0.5deg] rounded-lg z-[1]" />
								<div className="absolute top-[-4px] left-[10px] right-[10px] h-[20px] bg-[#fef3c7] rounded-lg z-[2]" />
							</>}

							{/* === Main Open Book Cover === */}
							<div className={`${isWorkbookSectionPath ? "relative rounded-xl shadow-2xl overflow-visible bg-amber-300 z-[5]" : ""} `}>

								{/* Spine / center crease */}
								{hasFacilitatorData && isWorkbookSectionPath && (
									<div className="absolute lg:block hidden top-0 bottom-0 left-1/2 -translate-x-1/2 w-[2px] z-10 pointer-events-none bg-[linear-gradient(to_bottom,transparent,rgba(7,89,133,0.15)_20%,rgba(7,89,133,0.25)_50%,rgba(7,89,133,0.15)_80%,transparent)]" />
								)}

								{/* ── Book inner pages area ── */}
								<div className="flex lg:flex-row flex-col">
									{/* LEFT PAGE */}
									{isWorkbookSectionPath && hasFacilitatorData && (
										<div className="flex-1 p-8 relative z-20">
											<div className="rounded-xl p-6 h-full bg-[rgba(255,255,255,0.85)] border-[1.5px] border-[rgba(7,89,133,0.1)] shadow-[inset_0_2px_8px_rgba(7,89,133,0.06)]">
												{leftContent}
											</div>
										</div>
									)}

									{
										sectionData?.length > 0 ? (
											<div className={`${isWorkbookSectionPath ? "flex-1 p-8 relative z-20" : ""} ${!hasFacilitatorData && 'w-full'}`}>
												<div className={`${isWorkbookSectionPath ? "rounded-xl p-6 h-full bg-[rgba(255,255,255,0.85)] border-[1.5px] border-[rgba(7,89,133,0.1)] shadow-[inset_0_2px_8px_rgba(7,89,133,0.06)]" : ""}`}>
									{otherPathname === "/coaching-form" && (<div className='invisible hidden'>
										<div ref={containerRef}>
											{allCoachingParts?.map((part, partIndex) =>
												part?.map((section) => (
													<span key={`${partIndex}-${section.item_id}`} className='disabled-dark font-large'>
														{renderTemplate(section)}
													</span>
												))
											)}
										</div>
									</div>
									)}

									{/* Section 4, Page 4 - Displaying checkbox items in 3 rows.  */}
									{
										itemsBeforeTarget.length > 0 && (
											itemsBeforeTarget?.map((section) => {
												return <span key={section.item_id} className='disabled-dark font-large'>{renderTemplate(section)}</span>
											})
										)
									}
									{
										itemsAfterTarget.length > 0 && (
											<div className='flex flex-wrap gap-4 justify-between flex-col'>
												{
													// Initialize a new array to hold grouped sections
													itemsAfterTarget.reduce((acc, section) => {
														// Check if the current section has template_id "2"
														if (section.template_id === "2") {
															// Start a new group for template_id "2"
															acc.push(
																<div key={section.item_id} className="child">
																	<span key={section.item_id} className='disabled-dark font-large'>
																		{renderTemplate(section)}
																	</span>
																</div>
															);
														} else {
															// Add the current section to the last group (child div)
															if (acc.length > 0) {
																// Add item to the last group
																const lastChild = acc[acc.length - 1];
																const updatedChild = (
																	<div key={lastChild.key} className="flex gap-2 flex-wrap items-baseline">
																		{lastChild.props.children}
																		<span key={section.item_id} className='disabled-dark font-large'>
																			{renderTemplate(section)}
																		</span>
																	</div>
																);
																acc[acc.length - 1] = updatedChild; // Update lastChild with new content
															}
														}
														return acc; // Return the updated accumulator (the array of JSX groups)
													}, []) // Start with an empty array to accumulate the divs
												}
											</div>
										)
									}
									{
										finalSections
										.filter(sec => !(sec.section_id === "4" && sec.part_id === "4"))
										.map((section) => {
											return <span key={section.item_id} className='disabled-dark font-large'>{renderTemplate(section)}</span>
										})
									}
												</div>
											</div>
										) :
											null
									}

								</div>
							</div>
						</div>

						{sectionData?.length > 0 ? (<Row className='mt-16'>
										<Col span={24}>
								{enableTill === counter && loginType === "0" && sectionId > 0 ? <Alert className='font-bold text-red-500 text-base w-fit py-1.5 mt-2 mb-4' message={constants.SectionApprovalMessage} type='error' /> : null}
											<Space size={'small'} wrap>
												{/* tick icon if admin has dissed the page */}
												{
													lastDiscussedPartId && counter <= parseInt(lastDiscussedPartId) ?
														(<CheckOutlined />) :
														null
												}
												{
													loginType !== "0" && counter < enableTill ?
														(<Button className='bg-amber-300 text-black uppercase' disabled={loader ? true : false} onClick={handleAdminDiscussed}>{constants.Discussed}</Button>) :
														null
												}
												{
													enableTill === counter && loginType !== "0" ?
														<Button className={'bg-amber-300 black-white uppercase'} disabled={loader ? true : false} onClick={handleSubmit}>{constants.Completed}</Button> :
														null
												}
												{
													previousBtn({})
												}
												{
													nextBtn({})
												}
												{
													(enableTill === counter && loginType === "0" ||  (displayGamblingValidateMessage && !isGamblingAnswered)) ?
														(!isTestsPage && <Button className={'bg-sky-800 text-white uppercase'} disabled={loader ? true : false} onClick={handleSubmit}>{constants.Submit}</Button>) :
														null
												}
												{
													//removed save and close for medical info release form
													counter !== enableTill && sectionId > 0 && !displayGamblingValidateMessage/* && !is_parent_concent */ ?
														(<Button className='bg-sky-800 text-white uppercase' disabled={loader ? true : false} onClick={handleSaveAndClose}>{constants.SaveClose}</Button>)
														: null
												}
												{/* resume button condition for admin and client side */}
												{
													sectionId === "0" ? null : displayResumeButton()
												}
												{/* close button for admin */}
												{
													loginType !== "0" && counter === sectionLength ?
														(<Button className='bg-sky-800 text-white uppercase' onClick={handleClose}>{constants.CloseBtn}</Button>) :
														null
												}
											</Space>
											{/* Family / Codependency validation message */}
											{familyCodependencyMessage ? (
												<div className="font-semibold text-lg">
													{familyCodependencyMessage}
												</div>
											) : null}
											{/* To display validate message for gambling section page. */}
											{displayGamblingValidateMessage ? (
												<div className="font-semibold text-lg">{constants.GamblingValidateMessage}</div>
											) : null}
										</Col>
						</Row>) : null}

					</Form>
					<div style={{ visibility: "hidden" }}>
						<b>partId:</b> {counter}
					</div>
				</div>

				{getModal()}
				{/* {noteValue && notesModel(hideModal, notesVisible, onchangeNoteValue, createNote, getForm, noteValue, noteTypeValue, isNoteAnswered, DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", false), onSessionChange, sessionChecked, false, null, null, assessmentBehavior, handleAssessmentBehaviorChange)} */}
				{noteValue && (
					<NotesModal
						hideModal={hideModal}
						notesVisible={notesVisible}
						onchangeNoteValue={onchangeNoteValue}
						createNote={createNote}
						getForm={getForm}
						noteValue={noteValue}
						noteTypeValue={noteTypeValue}
						disable={isNoteAnswered}
						date={DOB(
							noteDate.month,
							handleNoteMonthChange,
							noteDate.date,
							handleNoteDayChange,
							noteDate.year,
							handleNoteYearChange,
							"Date",
							false
						)}
						onSessionChange={onSessionChange}
						sessionChecked={sessionChecked}
						isSessionPresent={false}
						nextPreviousButton={null}
						isEdit={null}
						assessmentBehavior={assessmentBehavior}
						handleAssessmentBehaviorChange={handleAssessmentBehaviorChange}
						notefollowUp={notefollowUp}
						onFollowUpChange={onFollowUpChange}
					/>
				)}
			</div>
		</Spin>
	)
}

export default WorkbookSections;